export const no = {
    addDatabase: {
        addDatabase: "Legg til database",
        addFromFile: "Legg til fra fil",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Alle pakker",
        onePackage: "Ãn pakke",
        priceType: "Pristype",
        setPriceVatVisibility: "Momssynlighet",
        setVisibilityAndOrder: "Still inn synlighet og rekkefÃ¸lge pÃ¥ pristyper",
        withAndWithoutVat: "BÃ¥de med og uten moms",
        withVat: "Kun med moms",
        withoutVat: "Kun uten moms"
    },
    barvis: {
        base: "Basenavn",
        bigCanSize: "Stor boks/spann",
        coating: "Grunnmaling",
        identifier: "Identifikator",
        laboratory: "Laboratorium",
        orderOverview: "Ordreoversikt",
        rank: "Rangorden",
        smallCanSize: "Liten boks/spann"
    },
    basicSetup: {
        alreadyLoggedIn: "Du er allerede logget inn som %{login}.",
        askSupplier: "Be programvareleverandÃ¸ren om Ã¥ tildele deg lisens.",
        asterisk: "Felt markert med en stjerne mÃ¥ utfylles.",
        identificationKeys: "IdentifikasjonsnÃ¸kler",
        importCustomData:
            "Hvis det er relevant, skal du importere brukerdefinerte data fra den tidligere programvaren for fargeblanding.",
        learnIdentification: "FÃ¥ identifikasjonsnÃ¸kkelen fra programvareleverandÃ¸ren.",
        login: "FÃ¸lgende trinn av det innledende oppsettet krever administrative rettigheter",
        noDatabase: "Ingen databaser er lagt til enda, minst Ã©n skal vÃ¦re innsatt.",
        offlineLicensing: "Offline lisensiering",
        productSelection: "Produktvalg",
        registrationForm: "Registreringsskjema",
        seeQuestionMark: "Se de smÃ¥ spÃ¸rsmÃ¥lstegnene for Ã¥ lÃ¦re mer om innstillingen.",
        selectDefaultPrinter: "Velg standardskriver, og still inn ytterligere konfigurasjon.",
        selectDefaultTemplate: "Velg standardmal fra de allerede eksisterende, opprett en ny eller last opp din egen.",
        selectDispenser: "Velg hvilken type fargeblandingsmaskin du bruker.",
        selectLanguage: "Velg sprÃ¥k.",
        selectProducts: "Velg et av de tilgjengelige produktene du vil aktivere.",
        selectSpectroType: "Velg spektrometertypen du bruker.",
        setAdditionalPrinterOptions: "Angi ytterligere skriverinnstillinger.",
        setAutomaticUpdates: "Angi innstillingene for automatiske oppdateringer.",
        setCustomItems: "Angi spesialfremstilte varer og datasynlighet. Rull nedover for Ã¥ se flere muligheter",
        setEnvironment: "Angi programvarens overordnede omgivelser. Rull nedover for Ã¥ se flere muligheter.",
        setFormulaRepresentation: "Angi oppskriftsrepresentasjonen. Rull nedover for Ã¥ se flere muligheter.",
        summary:
            "Du kan endre i disse innstillingene nÃ¥r som helst og finne konfigurasjonsmuligheter. Kos deg med Ã¥ bruke %{name}!",
        summarySuccess: "Du er lagt inn i systemet!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Angi kanisternivÃ¥",
        criticalLevelCanister: "Kritisk kanisternivÃ¥",
        fillToMax: "Fyll til maks.",
        maxDispenseLevel: "Maksimal dosering",
        otherCanisters: "Andre kanisternivÃ¥er",
        warningLevelCanister: "Advarsel om kanisternivÃ¥er"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "Tilgjengelige tjenester",
        canisterInformation: "Kanisterinformasjon",
        canisterPreview: "ForhÃ¥ndsvisning av kanistere",
        currentLevel: "NÃ¥vÃ¦rende nivÃ¥",
        errors: "Feil",
        fillState: "PÃ¥fyllingsstatus",
        fillToMax: "Fyll til maks.",
        fillingAmount: "PÃ¥fyllingsmengde",
        finalLevel: "Endelig nivÃ¥",
        minimumAmount: "Minimumsmengde",
        minimumLevel: "MinimumsnivÃ¥",
        moveTableToRefill: "Flytt bordet for Ã¥ fylle pÃ¥ nytt",
        refillNoAmount: "Ingen mengde registrert",
        refillOverLimit: "Den inntastede mengden overskrider den maksimale kanisterkapasiteten.",
        refillSummary: "%{amount} %{unit} av brekkfargen %{colorant} blir lagt til beholderen %{canisterId}.",
        systemWarningAmount: "Mengde ved systemadvarsel",
        warningAmount: "Mengde ved advarsel"
    },
    changeDatabase: {
        changeDatabase: "Endre databasen ",
        databaseWarning: "Database %{databaseName} kan ikke brukes pga"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "RengjÃ¸r alle kanaler",
        cleanChannels: "RengjÃ¸r kanaler",
        cleaningTime: "RengjÃ¸ringstid",
        selectChannels: "Velg kanaler",
        startCleaning: "Start rengjÃ¸ring "
    },
    clientServerSettings: {
        activeServer: "Aktiv server",
        addNewServer: "Legg til ny server",
        availableServers: "Andre tilgjengelige servere",
        clientIdentifier: "Klientidentifikator",
        clientServerSettings: "Klient/server-innstillinger",
        disabledStatus: "Deaktivert",
        editServer: "Rediger server",
        fillRequiredFields: "Obligatoriske felt mÃ¥ utfylles",
        noOtherServers: "Det finnes ingen andre servere til rÃ¥dighet",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "OverfÃ¸r",
        serverName: "Servernavn",
        serverNameMissing: "Servernavn mÃ¥ utfylles",
        stabileConnection: "Bruk statisk IP-adresse for Ã¥ sikre en stabil forbindelse.",
        wrongFormatIp: "Feil format av IP-adresse"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Fargetone",
        fandeckPosition: "Farvekartets posisjon",
        moreInfoIcons: "Mer info ikoner",
        notExistingFormula: "Ikke-eksisterende oppskrift",
        orderBy: "Bestilling av",
        selectYourGrid: "Velg rutenett",
        showInPanel: "Vis i panelet",
        warningIcon: "Advarselsikon for ikke-eksisterende oppskrift"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Antall tonepastaer:",
        preview: "ForhÃ¥ndsvisning",
        prices: "Priser"
    },
    currencySettings: {
        addNewCurrency: "Legg til ny valuta ",
        codePlaceholder: "Kode",
        currencySettings: "Valutainnstillinger",
        namePlaceholder: "Navn",
        ratePlaceholder: "Valutakurs",
        setDecimalPlaces: "Still inn antall desimaler",
        setMainCurrency: "Still inn primÃ¦r valuta",
        setRounding: "Avrunding",
        symbolPlaceholder: "Symbol"
    },
    customFandecks: {
        customFandecks: "Spesiallaget fargekart",
        deleteButtonWarning: "Alle formler i fargekartet vil ogsÃ¥ bli fjernet.",
        deleteCustomFandeck:
            "Vil du virkelig slette dette spesiallagde fargekartet? Alle formler i fargekartet vil ogsÃ¥ bli slettet.",
        disableStandardFandecks: "Vis bare spesiallaget fargekart",
        enableStandardFandecks: "Vis standard fargekart",
        fandeckName: "Fargekartets navn "
    },
    customRedlike: {
        addColorantFromBrand: "Legg til brekkfarge fra %{brandName} merke",
        addNewCustomer: "Legg til ny kunde",
        addNewNote: "Legg til nytt notat",
        addedDate: "Ytterligere data",
        addedQuantity: "Ytterligere kvantitet",
        availableMachine: "Maskinen er tilgjengelig",
        brand: "Merke",
        brandPlease: "Velg merke",
        cancelCustomer: "Annuller kunde",
        colorPlease: "Velg farge",
        confirmCustomerData: "Bekreft kundedata",
        confirmNoteData: "Bekreft notatopplysninger",
        confirmSelectedUser: "Ãnsker du Ã¥ bruke denne kunden %{customerName} til denne ordren?",
        confirmed: "Bekreftet",
        controlData: "Endelig datakontroll",
        customerCellNumber: "Kundetelefonnummer",
        customerFilter: "Kundefilter",
        customerName: "Kundenavn",
        customerPhone: "Kundetelefon",
        customerPlease: "Velg kunde",
        dateFilter: "Datofilter",
        enterPin: "Tast inn adgangskode",
        enterTheNumberOfPackages: "Tast inn antall pakker",
        existingCustomer: "Bruker eksisterer allerede",
        fandeckPlease: "Velg fargekart",
        fillCanisterHistory: "Fyll ut kanisterhistorikk",
        findCustomer:
            "Hvis du skal tildele lojalitetskort til denne ordren, mÃ¥ du skanne strekkoden eller sÃ¸ke pÃ¥ e-post-adressen",
        findCustomerByEmail: "Filtrer kunder pÃ¥ bakgrunn av e-post eller strekkode",
        finishPreviousStep: "(FullfÃ¸r tidligere trinn)",
        formulaUnit: "Oppskriftsenhet",
        getBackToList: "Tilbake til kundeliste",
        historyOfOrders: "Ordrehistorikk",
        insertNote: "GÃ¥ til innsetting av notat",
        loadHistoryOrder: "Vil du laste opp valgt ordre?",
        loyaltyCards: "Lojalitetskort",
        machineIsAvailable: "MASKINEN ER KLAR",
        machineIsUnavailable: "MASKINEN ER IKKE KLAR",
        newLoyaltyCard: "Nytt lojalitetskort",
        noAvailableMachine: "Maskinen er ikke klar",
        noCustomerSelected: "Ingen kunder er valgt. Vil du fortsette?",
        notePlease: "Sett inn notat",
        openHistory: "Ãpen historikk",
        orAdd: "eller legg til kunde",
        orSelect: "eller velg kunde",
        orderModification: "Den opprinnelige kommandoen vil bli endret. Vil du fortsette?",
        orderOverview: "Ordreoversikt",
        orderToMachine: "SEND MIN ORDRE TIL MASKINEN",
        ordersHistory: "Ordrehistorikk",
        packagePlease: "Velg pakke",
        pleaseSelectBrand: "Velg merke",
        previewImage: "IMG-forhÃ¥ndsvisning",
        previewPackage: "ForhÃ¥ndsvisning av pakke",
        productPlease: "Velg produkt",
        resetFilters: "Nullstill alle filtre",
        searchForHistoricalOrders: "Eller sÃ¸k etter ordrer i historikk",
        selectBrand: "Velg merke",
        selectColor: "GÃ¥ til valg av farge",
        selectCustomer: "GÃ¥ til valg av kunde",
        selectExistingCustomer: "Velg eksisterende kunde",
        selectFandeck: "GÃ¥ til valg av fargekart",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "GÃ¥ til valg av pakke",
        selectProduct: "GÃ¥ til valg av produkt",
        shotsCoefficient: "Shots-koeffisient",
        showDetail: "Vis detaljer",
        showHideEshopName: "Vis / skjul eshop -navnet pÃ¥ fargen i en egen kolonne",
        showKeyboard: "Vis tastatur",
        skipCustomerButton: "Hopp over valgte kunder",
        skipCustomerText: "Hopp over hvis du ikke Ã¸nsker Ã¥ legge inn en kunde",
        skipNote: "Hopp over notat og se sammendraget",
        spectroBrand: "SÃ¸ker i merkevaren %{brandName}",
        statusAccepted: "akseptert",
        statusCanceled: "annullert",
        statusCreated: "opprettet",
        statusDone: "utfÃ¸rt",
        statusPartlyDone: "delvis utfÃ¸rt",
        statusPreparing: "forbereder",
        summaryChosenBase: "base",
        summaryChosenBrand: "merke",
        summaryChosenCanSize: "StÃ¸rrelse pÃ¥ boks/spann",
        summaryChosenColor: "farge",
        summaryChosenColorCard: "fargekart",
        summaryChosenProduct: "produkt",
        summaryChosenQuantity: "mengde",
        summaryColorPreview: "FargeforhÃ¥ndsvisning",
        summaryCustomNote: "Brukerdefinert notat",
        summaryCustomerNumber: "kundenummer",
        summaryFormula: "Oppskrift",
        summaryFormulaNote: "Oppskriftsnotat",
        summaryNote: "notat",
        sureAboutSend: "Er du sikker pÃ¥ at du vil sende en ordre?",
        useCustomerInOrder: "Ãnsker du Ã¥ bruke denne kunden %{customerName} til denne ordren?",
        uuid: "UUID (universell unik identifikator)",
        viewSummary: "Se sammendrag",
        volume: "Volum"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Bekreft ordrebekreftelse",
        pinScreenSaverConfirmation: "Bekreft skjermsparerbekreftelse",
        pinSettingsConfirmation: "Bekreftelse pÃ¥ PIN-innstilling",
        printAuto: "Tillat automatisk utskrift",
        printerSettings: "Skriverinnstillinger",
        selectColorWithFandeck: "Ofte valgte farger og fargekart",
        setKeyboard: "Still inn tastatur",
        setKioskMode: "Still inn full skjerm",
        setLanguage: "Still inn sprÃ¥k",
        setModule: "Still inn modul",
        setQuickSelect: "Still inn hurtigvalg",
        setScreensaverTimeout: "Still inn utlÃ¸pstid for pauseskjerm",
        setUnit: "Still inn enhet "
    },
    customRedlikeMachine: {
        action: "Handling",
        additionalPrint: "Ekstra utskrifter",
        brand: "Merke",
        brandAccess: "Bruker '%{userName}' fÃ¥r ikke tilgang til data fra merket '%{brandName}'",
        can: "Boks/spann plassert",
        canistersLevel: "KanisternivÃ¥oversikt",
        closeDetailInformation: "Lukk detaljer",
        colorantsAmount: "Mengde tonepasta",
        confirmRefill: "Bekreft pÃ¥fylling av tonepasta",
        deleteOrder: "Slett ordre",
        dialogNoMachine: "Maskinen er ikke tilkoblet",
        dialogNoRcc: "Ingen RCC er tilkoblet",
        dispense: "Fargeblanding",
        dispenserInErrorState: "Det er en feil pÃ¥ fargeblandemaskinen",
        dispensingIsOk: "Fargeblandemaskinen er OK",
        emergencyButtonPressed: "NÃ¸dstoppknappen er trykket inn",
        errorCode: "Feilkode",
        errorEvents: "Feil pÃ¥ fargeblandemaskinen",
        errorReset: "Omstartsfeil",
        explanation: "Forklaring",
        imageNotAvailable: "Bildet er ikke tilgjengelig",
        incorrectCanister: "Den skannede kanisteren er feil!",
        incorrectColorant: "Feil: Den skannede tonepastaen er feil. Velg riktig tonepasta.",
        lastEvents: "Siste hendelse",
        machineActions: "Sensor pÃ¥ fargeblandemaskinen",
        machineConfiguration: "Konfigurasjon av fargeblandemaskinen",
        machineError: "Maskinfeil",
        machineIsBusy: "Maskinen er opptatt",
        machineNotAvailable: "Maskinen er ikke tilgjengelig",
        machineTinting: "Vent, maskinen blander farge ...",
        manualScan: "Manuell skanning",
        notEnoughSpace: "FEIL: Det er ikke nok plass til denne tonepastapakken",
        numberOfCanistersUnderCriticalLevel: "Antall kanistere under kritiske nivÃ¥er er %{0}",
        numberOfCanistersUnderWarningLevel: "Antall kanistere under varselsnivÃ¥er er %{0}",
        offlinePressed: "Offline-tasten er aktivert",
        orderSettings: "Ordreinnstillinger",
        otherOrderInformation: "Ordredetaljer",
        packageCount: "Pakkeopptelling",
        packageWithSeparator: "Pakke",
        received: "Mottatt",
        receivedOrders: "Mottatt ordre",
        receivedTime: "Mottakstidspunkt",
        recirculation: "Resirkulering",
        refillInformation: "Tonepasta: %{0}, Oppfylling: %{1}, Kanister: %{2}",
        resetErrors: "Nullstillingsfeil",
        scanCanister: "Skann denne kanisteren",
        scanColorantPackage: "Skann passende tonepastapakke",
        selectedOrder: "Utvalgt ordre",
        shelfMovingDown: "Hyllen beveger seg nedover",
        shelfMovingUp: "Hyllen beveger seg oppover",
        solution: "LÃ¸sning",
        startDispensing: "Start fargeblanding",
        stirring: "RÃ¸ring",
        touchToStartFilling: "Trykk for Ã¥ starte pÃ¥fylling av tonepasta",
        unknownBrand: "Ukjent merke"
    },
    customRedlikeSettings: {
        addPos: "Salgsstedsinformasjon (POS)",
        addServer: "Legg til server",
        adminOperations: "Admin operasjoner",
        adminSettings: "Admin-innstillinger",
        another: "En annen",
        aslOrService: "TegnsprÃ¥k eller betjening",
        availableMachines: "Tilgjengelige maskiner",
        barcode: "Strekkode",
        basicOperations: "Basale aktiviteter",
        canisterBarcodes: "Kanister-strekkode",
        canisterLevels: "Kanister-nivÃ¥er",
        closeConnection: "Lukk tilkoblingen",
        closeRedlike: "Lukk %{name}",
        databaseList: "Database",
        disabledStatus: "Deaktivert",
        dispenseLogicType: "Doseringens logikktype",
        dropServers: "Velg bort server",
        editServer: "Rediger server",
        lastEvent: "Siste hendelse",
        logOut: "Logg ut",
        machineConfiguration: "Konfigurasjon",
        maxDispenseAmount: "Maksimal doseringsmengde",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        openFrondesk: "Ãpen resepsjon",
        print: "Utskrivingsinnstillinger",
        rebootPC: "Omstart av PC",
        restartRedlike: "Omstart %{name}",
        restoreConnection: "Gjenopprett tilkobling",
        scanCanisterBarcode: "Skann kanisterens strekkode",
        scanOrDeleteCanisterBarcode: "Skann eller slett strekkode",
        setCanisterBarcode: "Still inn kanisterens strekkode",
        swVersion: "Programvareversjon",
        systemFunctions: "Systemfunksjon",
        userSettings: "Brukerinnstillinger "
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Rediger farge",
        editColorant: "Rediger tonepasta",
        emptyColorant: "En av tonepastaene er tomme",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formel for hovedprodukt",
        formulaForMasterProductWithParam: "Formel for hovedprodukt %{productName}",
        isNotAvailable: "er ikke tilgjengelig",
        noBaseSelected: "Base kreves",
        noColorantsSelected: "Ingen tonepasta er valgt",
        noFandeckSelected: "Fargekart kreves",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Produkt kreves",
        productPreview: "ProduktforhÃ¥ndsvisning",
        saveCustomRecipe: "Lagre spesialfargeblanding",
        saveIsNotAvailable: "Lagring er ikke tilgjengelig",
        showSiblingProducts: "Vis sÃ¸skenprodukter",
        siblingProducts: "SÃ¸skenprodukter etter hovedprodukt"
    },
    customersTab: {
        addCustomer: "Legg til kunde",
        additionalSettings: "Flere innstillinger",
        adress: "Adresse",
        createAndSelect: "Legg til og velg",
        createNewCustomer: "Opprett en ny kunde",
        editCustomer: "Rediger kunde",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Kontonummer",
        information: "Kontaktinformasjon",
        listOfCustomers: "Kundeliste",
        rabat: "Rabatt",
        selectCustomer: "Velg kunde",
        spentLastMonth: "Brukt siste mÃ¥ned",
        spentMoney: "Brukte penger",
        typeOfMargin: "Typer profitt",
        zipCode: "Postnummer"
    },
    dialog: {
        cheaperColorSearch: "Billigere fargesÃ¸k pÃ¥gÃ¥r",
        competitiveColorSearch: "Simulerende fargesÃ¸k er i gang",
        reallyChangeModule: "Vil du virkelig endre modulen?",
        reallyCloseRedlike:
            "Vil du virkelig lukke %{name}? Alle %{name} paneler vil bli lukket, og ulagrede endringer vil bli slettet.",
        reallyDeleteOrder: "Vil du virkelig slette denne ordren? All data om denne ordren vil bli slettet.",
        reallyRebootPC:
            "Vil du virkelig starte denne PC-en pÃ¥ nytt? Alle paneler vil bli lukket, og ulagrede endringer vil bli slettet.",
        reallyRestartRedlike:
            "Vil du virkelig starte %{name} pÃ¥ nytt? Alle paneler vil bli lukket, og ulagrede endringer vil bli slettet.",
        reallyShutdownPc:
            "Vil du virkelig slÃ¥ av denne datamaskinen? Alle %{name} paneler vil bli lukket, og ulagrede endringer vil bli slettet. ",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Doser kun maksimal mengde til fargeblanding",
        2: "Tillat manuell dosering med bruk av skala for mengder over den maksimale mengden til fargeblanding",
        3: "Fyll pÃ¥ under fargeblandingen (delt belÃ¸p i mindre biter)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Navn pÃ¥ fargekart"
    },
    editFormulaRgbModal: {
        apply: "PÃ¥fÃ¸r",
        blue: "BlÃ¥",
        green: "GrÃ¸nn",
        modalLabel: "Rediger farge",
        red: "RÃ¸d",
        tryGenerateRgb: "PrÃ¸v Ã¥ generere RGB med mengder med fargestoffer"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Lukk formelfanen automatisk",
        allowBarcodes: "Tillat strekkode",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Tillat kunder",
        allowDeleteConfirmation: "Tillat slettebekreftelse",
        allowDiskSpaceNotification: "Tillat varsling om diskplass",
        allowDispensing: "Tillat fargeblanding",
        allowFileTransfer: "Tillat automatisk filoverfÃ¸ring",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Tillat formelstatuspanel",
        allowInternalNotes: "Tillat interne notater",
        allowLight: "Tillat %{name}",
        allowOrderNotificationModal: "Vis nye ordremeldinger",
        allowOrdering: "Tillat bestilling",
        allowPricing: "Tillat prising",
        allowPrint: "Tillat utskrift",
        allowProductPreviewImage: "Vis produktbildeeksempel",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Tillat sÃ¸k etter billigere farger",
        allowSound: "Tillat ordremeldinger med lyd",
        allowSpectro: "Tillat spektrometer",
        allowTabs: "Tillat faner",
        applyZoom: "Tillat zoom",
        automaticLogout: "Automatisk avlogging",
        barcodeScan: "Strekkodeskanning",
        canisterBarcode: "Kanister-strekkode",
        canisterLevel: "KanisternivÃ¥",
        changelog: "Endringslogg",
        closeTab: "Lukk fane",
        colorDifference: "Color difference",
        colorPanelNavItem: "Fargepanel",
        competitiveColorSearch: "Simulerende fargesÃ¸k",
        customBanner: "Spesiallaget banner",
        customCurrencyFormat: "Valutaformat",
        customDateFormat: "Datoformat",
        customNumberFormat: "Nummerformat",
        customTimeFormat: "Tidsformat",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Vis rabatt",
        dispensingHistory: "Fargeblandingshistorikk",
        dispensingNotes: "Tillat fargeblandingsnotater",
        enableCustomers: "Aktiver kunder",
        enableDeleteConfirmation: "Aktiver slettebekreftelse",
        enableDispensing: "Aktiver fargeblanding",
        enableLight: "Aktiver %{name}",
        enableMarginMarkup: "Aktiver profitt (margin) eller Ã¸nsket profittprosent (markup)",
        enableNotes: "Aktiver notater",
        enableOrdering: "Aktiver bestilling",
        enableProductPreviewImage: "Aktiver produktbilde",
        enableSpectro: "Aktiver spektrometer",
        enableVirtualKeyboard: "Tillat virtuelt tastatur",
        environmentsSettings: "Omgivelsesinnstillinger",
        exportTranslationKeys: "Eksporter oversettelsesnÃ¸kler",
        formulaNotes: "Tillat oppskriftsnotat",
        hintTooltips: "VerktÃ¸ytips",
        image: "Farge + bildeÂ / mer informasjon",
        keyboardShortcuts: "Tastatursnarvei",
        languageBased: "SprÃ¥kbasert",
        lockYourComputer: "LÃ¥s datamaskinen",
        machineReset: "Nullstilling av maskin",
        manageTranslations: "Administrer oversettelse",
        margin: "Kun profitt (margin)",
        markup: "Kun Ã¸nsket profittprosent (markup)",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maksimalt antall oppskriftsfaner",
        memoryTabs: "Lagre nylig Ã¥pnede faner",
        moreInfo: "Farge + bildeÂ + mer informasjon",
        navigationItems: "Innstillinger for navigasjonselementer",
        newTab: "Ny fane",
        numberOfPriceGroups: "Antall prisgrupper",
        order: "Ordre",
        orderId: "Ordre-ID",
        ordersHistory: "Ordrehistorikk",
        overwriteLastTab: "Overskriv den siste oppskriftsfanen",
        priceCalculation: "Prisberegning",
        priceDefBothPurchasePrimary: "Begge primÃ¦rt kjÃ¸p",
        priceDefBothSellPrimary: "Begge primÃ¦rt salg",
        priceDefPurchaseOnly: "Bare kjÃ¸pesum",
        priceDefSellOnly: "Kun salgspris",
        priceDefinition: "Prisdefinisjon",
        priceGroupsEnabled: "Aktiver prisgrupper",
        runLightAtStartUp: "KjÃ¸r %{light} ved oppstart",
        screenSaverTimeout: "Pauseskjermens utlÃ¸pstid",
        selectedSpectro: "Valgt %{spectro} spektro.",
        selectedSpectroNone: "Ingen spektro valgt.",
        setAutomaticClientStart: "KjÃ¸r %{name} ved oppstart av datamaskin",
        setCustomHomeButton: "Startknapphandlinger",
        setDecimalPlaces: "Still inn antall desimaler",
        setFormulaPreview: "OppskriftsforhÃ¥ndsvisning",
        setFormulaUnit: "Still inn oppskriftsenhet",
        setFts: "Bruk fulltekstsÃ¸k",
        setInfoItemInRgb: "Data for forhÃ¥ndsvisning av farger",
        setKeyboardShortcuts: "Still inn tastatursnarveier",
        setKioskMode: "Still inn fullskjerm",
        setKioskModeOff: "SlÃ¥ av fullskjerm",
        setKioskModeOn: "SlÃ¥ pÃ¥ fullskjerm",
        setNavigationItems: "Still inn navigasjonselementer",
        setNavigationItemsList: "Still inn synlighet og rekkefÃ¸lge for navigasjonselementer",
        setOrderSearchItems: "Still inn ordresÃ¸keparametre",
        setRounding: "Still inn avrunding",
        setSearchParameters: "Still inn oppskriftssÃ¸keparametre",
        setTabLimit: "Still inn fanebegrensninger",
        setYourLanguage: "Still inn sprÃ¥k",
        setZoom: "Still inn zoom",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Denne innstillingen kan ikke endres, da dialogboksen er blitt deaktivert i maskinens innstillinger",
        sortItems: "Sorter navigasjonselementer",
        startDispensing: "Start fargeblanding",
        stir: "RÃ¸r"
    },
    error: {
        errorDetail: "Feildetaljer",
        errorOccurred:
            "Det oppsto en uventet feil. Kontakt teknisk stÃ¸tte pÃ¥ %{0}, sÃ¥ skal vi ta kontakt med deg sÃ¥ raskt vi kan.",
        hideDetail: "Skjul detaljer"
    },
    favoritesTab: {
        addFolder: "Legg til mappe",
        closeTabToLoadFormula: "Lukk en av formlene for Ã¥ Ã¥pne en ny fane. Du har nÃ¥dd maksimalt antall Ã¥pne faner",
        deleteFolder: "Slett mappe",
        editFolder: "Rediger mappe",
        favoriteFormulas: "Favorittoppskrifter",
        formulaNotes: "Oppskriftsnotat",
        message: {
            formulasFromFolder: "Oppskrift fra mappe",
            moveAllFormulas: "Flytt alle oppskrifter fra denne mappen til overordnede",
            removeAllFormulas: "Fjern alle oppskrifter fra denne mappen",
            wantToDeleteFolder: "Vil du virkelig slette denne mappen?"
        },
        newFolder: "Ny mappe",
        packages: "Pakker",
        pricePerPackage: "Pris pr. pakke",
        regularPrice: "Vanlig pris",
        removeFromFavorites: "Fjern fra favoritt",
        specialPriceOff: "Spesialtilbud %{number}% rabatt",
        specialPriceVIP: "Spesialtilbud VIP"
    },
    fileTransfer: {
        afterImport: "Etter import",
        alreadyExists: "Oppgave for gitt type og format finnes allerede",
        customFormulaSimple: "Egendefinert formel enkel",
        direction: "Retning",
        exportTask: "Fileksportoppgave",
        fileTransferNotification: "Varsel om filoverfÃ¸ring",
        flashMessage: "Flash -melding",
        importTask: "Filimportoppgave",
        noInformation: "Ingen informasjon",
        protocol: {
            folder: "Mappe",
            ftp: "FTP -protokoll",
            ftps: "FTPS -protokoll",
            redlikeStorage: "%{softwareName} FTP -lagringsprotokoll",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protokollkontroll av filer i definert lokal mappe.",
            ftp: "Protokollkontroll av filer i ekstern FTP -mappe ved bruk av standard FTP -tilkobling.",
            ftps: "Protokollkontroll av filer i ekstern FTPS (FTP-SSL / FTP Secure) server ved bruk av standard FTP-tilkobling.",
            redlikeStorage: "Protokollkontroll av filer i %{softwareName} -lagring."
        },
        remoteFolder: "Ekstern mappe",
        startType: "Starttype",
        statusbar: "Informasjon om statuslinjen",
        testConnection: "Test tilkobling",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Forbrukertype",
        filter: "Filter",
        from: "Fra",
        to: "Til"
    },
    findText: {
        findTextTitle: "SÃ¸k etter tekst",
        removeMarks: "Fjern merke",
        search: "SÃ¸k etter ord"
    },
    flashMessage: {
        VMNotAllowed: "Virtuell maskin er ikke tillatt.",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Automatisk databasepÃ¥logging mislyktes.",
        autotaskDuplicateName:
            "Databasens integritetsfeil: %{0} vare med %{1} %{2} finnes allerede, bruk forskjellige %{3}.",
        barcodeIsUsed: "Strekkoden brukes allerede",
        barcodeNotFound: "Strekkoden ble ikke funnet.",
        bugReportSent: "Programvarefeilrapporten er sendt.",
        cannoctConnectToServer: "Kan ikke koble til serveren.",
        cannotWriteLicense: "Kan ikke skrive lisens.",
        clientConnectionRejected: "Tilkoblingen er avvist.",
        clientNotLoggedIn: "Klienten er ikke logget inn.",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty: "Resultatene av simulerende fargesÃ¸k er tomme",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Datamaskinen er tilbakedatert.",
        connectionFailed: "Tilkoblingstesten mislyktes: %{0}",
        connectionSuccess: "Tilkoblingstesten var vellykket",
        corruptedLicenseFile: "Lisensfilen er skadet.",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Kunden ble ikke funnet.",
        dataNotAvailable: "Serveren kan ikke opprette tilkobling til databasen.",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Det oppsto en uventet feil under den siste serverhandlingen.",
        deleteAll: "Slett alle.",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "Du kan deaktivere vinter-programtillegg ved hjelp av rullelisten pÃ¥ hÃ¸yre side av fanenavigasjonen.",
        duplicateBarcode: "Det finnes allerede en dublettstrekkode",
        duplicateName: "Duplikat, navn finnes allerede.",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Lisensen er utlÃ¸pt.",
        exportSuccess: "Data er eksportert.",
        fandeckExist: "Dette spesiallagede fargekartnavnet finnes allerede.",
        featureNotAutorized: "Funksjonen er ikke godkjent.",
        fileExportComplete: "Filen ble eksportert.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Filen er ikke levert eller er tom.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Kunne ikke behandle data i filen, filen er ikke gyldig.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Kunne ikke oppdage versjonen av filen.",
        filetransferNoData: "Ingen databasetilkobling, sjekk innstillinger",
        formulaDataUnavailable: "Oppskriftsdata er ikke tilgjengelig.",
        helperDefaultMessage: "Det oppsto en uventet feil under den siste handlingen fra hjelpeserveren.",
        helperServerError: "Hjelpeserverfeil.",
        importAborted: "Importprosessen er avbrutt.",
        importSuccess: "Data er importert.",
        incompatibleBaseCan: "Base kan ikke vÃ¦re kompatibel med det angitte produktet, basen og pakken.",
        incorrectPassword: "Den gamle adgangskoden din er feil. Tast inn riktig kode.",
        invalidCurrency: "Valutakoden er ugyldig. Euro er innstilt som standardvaluta.",
        invalidDatabaseName: "Databasens navn er ugyldig.",
        invalidEmail: "E-posten din er ugyldig.",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Ugyldig nÃ¸kkel for virksomhetsbruker.",
        invalidLicenseFile: "Ugyldig lisensfil.",
        invalidLicenseIdentificationKeys: "LisensidentifikasjonsnÃ¸kkelen er ugyldig.",
        invalidLicenseKey: "Lisensen din er ugyldig",
        invalidLicenseProduct: "Lisensfilen samsvarer ikke med produktet.",
        invalidRccResponse:
            "Det oppsto en uventet feil under behandlingen av det siste RCC-svaret (Redlike Control Center).",
        invalidServerResponse: "Det oppsto en uventet feil under behandlingen av det siste serversvaret.",
        invalidUrl: "URL er ugyldig.",
        itemNotFound: "Produktet ble ikke funnet.",
        keyboardShortcutUsedInModal:
            "Denne tastatursnarveien kan ikke brukes i popup-vinduet. Lukk popup-vinduet fÃ¸rst.",
        keyboardShortcutValidation: "Ãn tastatursnarvei kan ikke stilles inn til to ulike handlinger.",
        licenseHasBeenRevoked: "Lisensen er blitt opphevet. Kontakt programvareleverandÃ¸ren for Ã¥ fornye den.",
        licenseProlongationNeeded: "Lisensforlengelse er nÃ¸dvendig (koble PC til Internett for Ã¥ fÃ¥ en ny lisens)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Produktet er opprinnelig lisensiert pÃ¥ en annen datamaskin.",
        logFileArchiveDownloadComplete: "Nedlasting av loggarkiv er avsluttet.",
        loginError: "Det oppsto en uventet feil under pÃ¥logging.",
        logoutError: "Det oppsto en uventet feil under utlogging.",
        machineIsConnecting: "Maskinen kobler til, vennligst vent.",
        machineIsNotConnected:
            "Maskinen din er IKKE TILKOBLET RCC. Kontroller RCC-konfigurasjonen (Redlike Control Center).",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maksimalt antall faner er nÃ¥dd. Lukk Ã©n av dem.",
        noTemplate: "Utskrift kan ikke utfÃ¸res, fordi det ikke er noen maler tilgjengelig.",
        openNewTab: "Ãpne en ny reseptfane for Ã¥ lese inn resepten ved hjelp av strekkode",
        orderAlreadyAcquired: "Ordren er allerede lagt inn, den skal frigis fÃ¸rst.",
        orderCreated: "Bestillingen er sendt.",
        passwordIsNotUnique: "Den nye adgangskoden skal ikke vÃ¦re lik den gamle.",
        printCannotBeCarriedOut: "Utskrift kan ikke utfÃ¸res, fordi skrivernavnet er ugyldig.",
        problemWithFileExport: "Det oppsto en feil under lagring av filen pÃ¥ disken.",
        productFileWarning: "Produktfil er bare tilgjengelig online.",
        productNotLicensed: "Produktet er ikke lisensiert.",
        rccDefaultMessage: "Det oppsto en uventet feil under den siste RCC-handlingen (Redlike Control Center).",
        rccError: "RCC-feil (Redlike Control Center)",
        rccNeedRestart: "Start RCC (Redlike Control Center) pÃ¥ nytt.",
        restoredSettings: "Innstillingene er gjenopprettet.",
        revokedLicense: "Lisensen er blitt opphevet.",
        runningOutOfSpace: "Datamaskinen gÃ¥r tom for ledig plass.",
        savedFormulaToHistory: "Oppskriften er lagret i fargeblandingshistorikk.",
        savedLogArchive: "Loggarkiv er lagret i biblioteket.",
        scanning: "Skanning pÃ¥gÃ¥r",
        serverError: "Serverfeil",
        setClientIdentifier: "Angi fÃ¸rst klient-ID.",
        showLess: "Vis mindre",
        showMore: "Vis mer",
        spectroIsDisconnecting: "Spektrometer kobler fra, vennligst vent.",
        spectroIsNotConnected:
            "Spektrometeret er IKKE TILKOBLET i dette Ã¸yeblikket. Kontroller RCC-konfigurasjonen (Redlike Control Center).",
        spectroIsNotSelected:
            "Spektrometer er IKKE VALGT i dette Ã¸yeblikket. Kontroller RCC-konfigurasjonen (Redlike Control Center).",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Ukjent feil: %{0}",
        userAlreadyLoggedIn: "Du er allerede logget inn.",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Kunne ikke opprette tilkobling til Web Api-serveren.",
        webApiInternalError: "Web Api-server â intern feil",
        webApiInvalidUser: "Web Api-server â ugyldig bruker",
        webApiNoLicenseAvailable: "Web Api-server â ingen lisens tilgjengelig",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Feil format til %{0} inntasting.",
        wrongRccVersion:
            "Sjekk din versjon av RCC (Redlike Control Center). Din klient er kun kompatibel med RCC (Redlike Control Center) %{0}. "
    },
    footer: {
        aboutApplication: "Om sÃ¸knad",
        activeUser: "Aktiv bruker",
        logOut: "Logg av",
        machineErrors: "Maskinfeil"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Alle enheter som er tilgjengelige i databasen",
        allowCustomFormulas: "Tillat spesiallagede oppskrifter",
        allowCustomPackageSize: "Tillat spesiallaget pakkestÃ¸rrelse",
        allowFormulaAutomaticNaming: "Tillat automatisk navngivning",
        automaticNaming: "Automatisk oppskriftsnavngivning",
        basePanelSize: "Angi stÃ¸rrelse pÃ¥ grunnpanel",
        bippPanelSize: "Angi stÃ¸rrelsen pÃ¥ basen i produktpakken",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Fargepanel",
        colorPreviewAsImage: "ForhÃ¥ndsvis farge som bilde",
        colorPreviewResizable: "ForhÃ¥ndsvisbar farge forhÃ¥ndsvisning",
        competitiveColorSearch: "Simulerende fargesÃ¸k",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Spesiallagede oppskrifter",
        customPackageSettingsUnitGrav: "Egendefinerte pakkeinnstillinger gravimetrisk enhet",
        customPackageSettingsUnitVol: "Tilpasset pakkeinnstillinger volumetrisk enhet",
        customPackageSize: "Spesiallaget pakkestÃ¸rrelse",
        customUnits: "Velg spesialenheter",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Rediger tonepastaer",
        editColorantsAllowed: "Tillat tonepastaredigering",
        fandeckPanelSize: "Angi stÃ¸rrelsen pÃ¥ viftepanelet",
        favoriteFormulas: "Favorittoppskrifter",
        formulaColorPreview: "ForhÃ¥ndsvisning av oppskriftsfarge",
        formulaDataSettings: "Datainnstillinger for oppskrift",
        formulaPanel: "Oppskriftspanel",
        formulaPanelSize: "Angi stÃ¸rrelsen pÃ¥ formelpanelet",
        formulaSettings: "Oppskriftsinnstillinger",
        generateColorPreview: "Lag forhÃ¥ndsvisning av farger",
        gravimetricOnly: "Kun gravimetriske enheter",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Bruk bare bilde fra lokal database",
        imagesOnline: "PrÃ¸v fÃ¸rst og fremst Ã¥ Ã¥pne et online bilde, hvis det mislykkes, Ã¥pne det lokale bildet",
        infoPanelResizable: "Endre stÃ¸rrelse pÃ¥ mer infopanel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Enheten avhenger av det valgte produktet",
        productFilesDialog: "Vis dialogboks for Ã¥ Ã¥pne lokal fil eller online fil",
        productFilesLocal: "Bruk bare produktfiler fra lokal database",
        productFilesOnline: "PrÃ¸v fÃ¸rst og fremst Ã¥ Ã¥pne online produktfil, hvis den mislykkes, Ã¥pne den lokale filen",
        productPanelSize: "Angi stÃ¸rrelsen pÃ¥ produktpanelet",
        searchPanelQuickSelect: "Hurtigvalg",
        setAdditionalFormulaPanel: "Still inn ekstra oppskriftspanel",
        setCompetitiveColorSearch: "Tillat simulerende fargesÃ¸k",
        setInitialFormulaPanel: "Still inn innledende oppskriftspanel ",
        setMaxToleranceForCompetitiveColors: "Still inn maksimal toleranse for simulerende fargesÃ¸k",
        setNumberOfCompetitiveColors: "Still inn antall simulerende farger",
        setSearchPanel: "Still inn sÃ¸kepanel",
        setVisibilityAndOrder: "Still inn synlighet og rekkefÃ¸lge pÃ¥ ulike oppskriftsdata",
        setVisibleUnit: "Still inn synlig enhet",
        showColorPreview: "Vis forhÃ¥ndsvisningen av fargen",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Sortering av fargepaneler",
        useBase: "Bruk valgelementet til basen",
        useBaseInProductPackage: "Bruk valgelement for base i produktpakken",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Bruk valgelementet for produktet",
        useProductCode: "Bruk av produktkode",
        useProductGroups: "Bruk produktgrupper",
        volumetricOnly: "Kun volumetriske enheter"
    },
    general: {
        accepted: "Accepted",
        active: "Siste aktivitet",
        actual: "Virkelig",
        actualLevel: "NÃ¥vÃ¦rende nivÃ¥",
        add: "Legg til",
        addColorant: "Legg til tonepasta",
        addColorantForPackage: "Add colorant for package",
        addFile: "Legg til fil",
        all: "Alle",
        amount: "Mengde",
        applyNow: "Apply now",
        attachments: "Vedlegg",
        automaticCorrection: "Automatic correction",
        automatically: "Automatisk",
        available: "Tilgjengelig",
        back: "Tilbake",
        base: "Utgangspunkt",
        baseInProductPackage: "Base i produkt og pakke",
        batchNumber: "Batch number",
        bottom: "Bunn",
        buildingSite: "Building site",
        calculate: "Regne ut",
        can: "Boks/spann",
        canSize: "StÃ¸rrelse pÃ¥ boks/spann",
        cancel: "Annuller",
        canister: "Beholder",
        canisterId: "Kanister-ID",
        canisterIndex: "Beholderindeks",
        canisters: "Kanistere",
        cap: "Lokk",
        capacity: "Kapasitet",
        channels: "Kanaler",
        choose: "Velg",
        city: "Sted",
        clean: "RengjÃ¸r",
        clear: "Klar",
        client: "Klient",
        close: "Lukk",
        closeAll: "Lukk alle",
        collapseAll: "Skjul alle",
        color: "Farge",
        colorCode: "Fargekode",
        colorFile: "Colorfile",
        colorName: "Fargenavn",
        colorPreview: "ForhÃ¥ndsvisning av farge",
        colorant: "Tonepasta",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Tonepastapakke",
        colorants: "Tonepastaer",
        colors: "Colors",
        company: "Firma",
        competitiveColor: "Competitive color",
        confirm: "Bekreft",
        confirmDeletion: "Vil du virkelig slette denne varen permanent?",
        confirmHelpSettings: "Vil du virkelig lagre dette skjemaet og la feltet stÃ¥ tomt?",
        connect: "Koble til",
        continue: "Fortsett",
        correction: "Correction",
        country: "Land",
        created: "Opprettet",
        creationDateOf: "Creation date of",
        criticalLevel: "Kritisk nivÃ¥",
        currency: "Valuta",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Spesiallaget",
        customData: "Custom data",
        customFandeck: "Spesiallaget fargekart",
        customFormula: "Egendefinert formel",
        customPackage: "Spesiallaget",
        customPackageSettings: "Tilpassede pakkeinnstillinger",
        customer: "Kunde",
        customerVersion: "Kundeversjon",
        customers: "Kunder",
        database: "Database",
        date: "Dato",
        default: "Misligholde",
        delete: "Slett",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Beskrivelse",
        disconnect: "Avbryt",
        discount: "Rabatt",
        discover: "Oppdag",
        dispense: "Doser",
        dispensing: "Doser",
        doNotShowAgain: "Ikke vis denne meldingen pÃ¥ nytt.",
        downloadingFile: "Laster ned filer",
        edit: "Rediger",
        email: "E-post",
        enabled: "Aktivert",
        error: "Feil",
        expandAll: "Utvid alle",
        exportData: "Eksporter data",
        exportPdf: "Eksporter PDF",
        fan: "Fargekart",
        fandeck: "Fargekart",
        fandeckCode: "Fandeck code",
        fandeckName: "Navn pÃ¥ fargekart",
        fandecks: "Fandecks",
        favorite: "Favoritt",
        fileTransfer: "FiloverfÃ¸ring",
        filling: "Sparkling",
        fillingDate: "Fyllingsdato",
        find: "Finn",
        finish: "Bli ferdig",
        finishedCorrection: "Finished correction",
        formula: "Oppskrift",
        formulas: "Formulas",
        frontdesk: "Resepsjonen",
        getQrCode: "FÃ¥ QR-kode",
        gravimetric: "Gravimetrisk",
        historical: "Historical",
        history: "Historikk",
        hours: "Hou.",
        id: "ID",
        images: "Bilder",
        in: "I",
        index: "Indeks",
        insertBarcode: "Tast inn strekkode",
        install: "Installer",
        installed: "Installert",
        instructions: "Bruksanvisning",
        internalNote: "Intern note",
        interval: "Intervall",
        ip: "IP-adresse",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Grense",
        load: "Laste",
        loadFormula: "Les inn oppskrift",
        localVersion: "Lokal versjon",
        machine: "Maskin",
        manualCorrection: "Manual correction",
        manually: "Manuelt",
        margin: "Profitt (margin)",
        markup: "Ãnsket profittprosent (markup)",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Maksimalt nivÃ¥",
        maxValue: "Maks.",
        maximum: "Maksimal",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarisme",
        minimum: "Minimal",
        minutes: "Min.",
        missingItem: "Manglende vare",
        missingRequiredItems: "Alle nÃ¸dvendige felter (markert med en stjerne) mÃ¥ utfylles",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Mer",
        moreInfo: "Mer informasjon",
        moveDown: "Flytt nedover",
        moveUp: "Flytt oppover",
        myOrders: "Mine ordre",
        name: "Navn",
        nameTitle: "TytuÅ",
        new: "Ny",
        next: "Neste",
        no: "Ingen",
        noColorantsAvailable: "Ingen tonepasta tilgjengelig",
        noFormulas: "Ingen oppskrift enda",
        noPricesAvailable: "Ingen priser til rÃ¥dighet",
        nominalAmount: "Nominell mengde",
        notAvailable: "Ikke tilgjengelig",
        note: "Notat",
        numberOfCanisters: "Antall kanistere",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Antall etiketter",
        numberOfPackages: "Antall pakker",
        off: "Slukket",
        ok: "Ok",
        on: "Tent",
        onFocus: "PÃ¥ fokus",
        open: "Ãpen",
        operator: "Operator",
        options: "Muligheter",
        order: "Order",
        other: "Andre",
        otherError: "Andre feil",
        out: "Ute",
        overwrite: "Overwrite",
        package: "Pakke",
        packagePreview: "ForhÃ¥ndsvisning av pakke",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "Vennligst vent",
        previous: "Previous",
        price: "Pris",
        priceGroup: "Prisgruppe",
        print: "Utskrift",
        printTask: "Utskriftsoppgave",
        processingStep: "Processing %{step}",
        product: "Produkt",
        productCode: "Produktkode",
        productName: "Produktnavn",
        products: "Produkter",
        pump1: "Pumpe 1",
        pump2: "Pumpe 2",
        purchasePrice: "KjÃ¸pspris",
        purge: "RengjÃ¸ring",
        qualityControl: "Quality control",
        quantity: "Mengde",
        quantityQty: "QTY",
        quickTint: "Hurtig fargeblanding",
        rccIsNotAvailable: "RCC er ikke tilgjengelig",
        rccIsNotConnected: "RCC (Redlike Control Center) er ikke tilkoblet",
        rccNotLicensed: "RCC er ikke lisensiert",
        reconnect: "Koble til pÃ¥ nytt",
        refill: "Fyll pÃ¥",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Nullstill",
        restart: "Omstart",
        restore: "Gjenopprett",
        retint: "Beholde",
        revision: "Revisjon",
        safetySheet: "Sikkerhetsark",
        save: "Lagre",
        saveAs: "Lagre som",
        saveToDispensingHistory: "Lagre til historikk",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sek.",
        select: "Select",
        selectAll: "Velg alle",
        selectChannels: "Velg kanaler",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Selg pris",
        settings: "Innstillinger",
        shelf: "Hylle",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "StÃ¸rrelse",
        skip: "Hopp over",
        smartPurge: "Smart rensing",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spektrometer",
        standardFormula: "Standard formel",
        status: "Status",
        street: "Gate",
        sum: "Sum",
        summary: "Sammendrag",
        sync: "Synkroniser",
        technicalSheet: "Teknisk ark",
        templates: "Maler",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Til fargeblanding",
        top: "Ãverst",
        total: "Total",
        totalAmount: "Totale mengden",
        totalBaseAmount: "Total basisbelÃ¸p",
        totalColorantAmount: "Total mengde fargestoffer",
        type: "Type",
        ufiCode: "UFI -kode",
        ufiThreshold: "UFI -terskel",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Enhet",
        units: "Enhet",
        unknown: "Unknown",
        update: "Oppdater",
        updated: "Oppdatert",
        user: "Bruker",
        value: "Verdi",
        vat: "Moms",
        verified: "Verified",
        version: "Versjon",
        versionId: "Versjons-ID",
        versionStructure: "Versjonsstruktur",
        volumetric: "Volumetrisk",
        warning: "Advarsel",
        warningLevel: "AdvarselsnivÃ¥",
        withoutName: "(uten navn)",
        workingProperly: "Working properly",
        yes: "Ja",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ be om at bÃ¸rstebeholderen rengjÃ¸res pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren mÃ¥ fjerne, rengjÃ¸re og deretter returnere bÃ¸rstebeholderen manuelt.",
            capMaintenance:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ be om rengjÃ¸ring av hetten pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren mÃ¥ rengjÃ¸re autocap manuelt nÃ¥r den Ã¥pnes.",
            cleanAll:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ utfÃ¸re automatisk rengjÃ¸ring av alle kanaler pÃ¥ et bestemt tidspunkt.",
            cleanChannels:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til automatisk Ã¥ utfÃ¸re rengjÃ¸ring av bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            computerReboot:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ datamaskinen til Ã¥ starte pÃ¥ nytt automatisk pÃ¥ et bestemt tidspunkt.",
            computerShutdown:
                "Still inn denne autooppgaven til automatisk Ã¥ slÃ¥ av datamaskinen pÃ¥ definerte tidsinnstillinger.",
            dispenserCleaning:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ be om rengjÃ¸ring av dispenseren pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren mÃ¥ rengjÃ¸re maskinen med en klut manuelt.",
            humidifierWaterLevelMaintenance:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ be om fylle pÃ¥ luftfukteren pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren mÃ¥ kontrollere og etterfylle vannet manuelt i luftfukteren.",
            purgeAll:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ rense alle kanaler pÃ¥ et bestemt tidspunkt.",
            purgeChannels:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ rense bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            recirculateAll:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ utfÃ¸re resirkulering av alle kanaler pÃ¥ et bestemt tidspunkt.",
            recirculateChannels:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ utfÃ¸re resirkulering av bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            refillAll:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ utfÃ¸re handlingen for etterfylling av alle kanaler pÃ¥ et bestemt tidspunkt.",
            refillCanisters:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ utfÃ¸re handlingen for etterfylling av bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            smartPurgeAll:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til automatisk Ã¥ utfÃ¸re smart rensning av alle kanaler pÃ¥ et bestemt tidspunkt. Rensingen vil bli utfÃ¸rt med mindre reglene for Smart-rensing er oppfylt.",
            smartPurgeChannels:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til automatisk Ã¥ utfÃ¸re smart rensning av spesifikke kanaler pÃ¥ et bestemt tidspunkt. Rensingen vil bli utfÃ¸rt med mindre reglene for Smart-rensing er oppfylt.",
            stirAll:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ utfÃ¸re omrÃ¸ring av alle kanaler pÃ¥ et bestemt tidspunkt.",
            stirCanisters:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ dispenseren til Ã¥ utfÃ¸re omrÃ¸ring av bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            switchPlateMaintenance:
                "Still inn denne autooppgaven til Ã¥ fÃ¥ %{name} til Ã¥ be om rengjÃ¸ring av switch-platen pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren mÃ¥ fjerne, rengjÃ¸re og deretter returnere kontaktplaten manuelt."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Tillat Ã¥ legge til en ny server manuelt hvis den ikke kan oppspores via oppdagerfunksjonen.",
            clientIdentifier:
                "Denne innstillingen gjÃ¸r det mulig Ã¥ identifisere denne klienten hvis det er flere klienter som er tilkoblet en server.",
            disconnect:
                "Opplysninger om den aktuelle anvendte serveren. Frakoblingsknappen gjÃ¸r det mulig Ã¥ forlate denne serveren og bytte til en annen hvis den er tilgjengelig.",
            discover: "Finn ut om det er andre servere som er tilgjengelig i dette nettverket.",
            dropServers: "Slett alle tidligere servere fra denne listen.",
            dropServersNotAvailable: "Ingen server tilgjengelig",
            edit: "Tillat manuell redigering i en allerede funnet server.",
            editDisabled: "Det er ikke valgt noen server."
        },
        continue: "Vil du virkelig fortsette?",
        driverSettings: {
            alfaRestApi: {
                host: "Tast inn datamaskinens vertsnavn eller IP-adresse.",
                machineType: "Gjelder for alle Alfa-maskiner. BÃ¥de Windows og Linux."
            },
            corobDsProxy: {
                machineType:
                    "Gyldig i generasjonene Slave (D200, D600 ..), 4G (First One) og 5G (EvoFlx). DspProxy mÃ¥ vÃ¦re installert. Kun Windows."
            },
            corobEvoDriver: {
                machineType: "Gyldig til generasjon 5G (EvoFlx). EVOservice mÃ¥ vÃ¦re installert. BÃ¥de Windows og Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Velg konfigurasjonsfilen for fargeblandingsmaskinen. Standardinnstilling.",
                hldRootDir: "Velg hovedmappen for HLD. Standardinnstilling.",
                machineType:
                    "Gyldig for Corob Flex (500, 520, 540) = tidligere Lenteq. HLD mÃ¥ installeres. Kun Windows."
            },
            corobNextDriver: {
                machineType:
                    "Gyldig i generasjonene Slave (D200, D600 ..), 4G (First One) og 5G (EvoFlx). NextDriver mÃ¥ vÃ¦re installert. Kun Linux."
            },
            dromontDDrv: {
                databasePath: "Bane til databasefilen med kalibreringsdata. Standardinnstilling.",
                driverPath: "Bane til driveren (D_DRV.exe). Standardinnstilling.",
                machineType:
                    "Indirekte dispenserkommunikasjon via bestemte baner. Gjelder i generasjoner V1 og V2. D_SET skal vÃ¦re installert. BÃ¥de Windows og Linux.",
                resultPath: "Bane til resultatfilen opprettet etter at operasjonen er over. Standardinnstilling.",
                serviceSoftwarePath: "Bane til Dromont-serviceprogramvaren (D_SET.exe). Standard forhÃ¥ndsinnstilt."
            },
            dromontDirect: {
                machineType:
                    "Direkte dispenserkommunikasjon. Gjelder i generasjoner V1 og V2. D_SET skal vÃ¦re installert. BÃ¥de Windows og Linux.",
                rootDir: "Velg hovedmappen Dromont, standardinnstilling."
            },
            dromontMisura: {
                driverPath:
                    "Bane til driveren (MisuraRetail.exe) kan kanskje bli endret basert pÃ¥ Misura Retail-versjonen. Standardinnstilling.",
                extensionPath: "Bane til kommunikasjonsfil til servicehandlinger.",
                formulaPath: "Bane til kommunikasjonsfil for fargeblanding.",
                machineType: "Gyldig til generasjon V3. Dromont Misura mÃ¥ vÃ¦re installert. Kun Windows."
            },
            fastAndFluidIDD: {
                machineType: "Gjelder for alle F & F-maskiner. Kun Windows.",
                path: "IDD2 stÃ¸ttes (HA 450, HA 650, X-smart osv.) â skal vÃ¦re lisensiert, IDD3 (HP 500 osv.), IDD4 (HA 180, HA 480, HA 680, Xprotint osv.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Gjelder for alle F & F-maskiner. BÃ¥de Windows og Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Gjelder for alle Hero-maskiner. Kun Windows."
            },
            italtinto: {
                machineType:
                    "Gjelder for alle Italtinto-maskiner. Wcal eller ItaltintoCal mÃ¥ vÃ¦re installert. Kun Windows.",
                path: "Bane til den justerte Italtinto-konfigurasjonsfilen."
            },
            manualAdvanced: {
                machineType: "Gjelder for alle manuelle maskiner, inkludert kanisterstÃ¸tte. BÃ¥de Windows og Linux.",
                path: "Bane til konfigurasjonsfilen med data om fargeblandingsmaskinen og beholderne."
            },
            manualSimple: {
                machineType: "Gjelder for alle manuelle maskiner. BÃ¥de Windows og Linux.",
                path: "Bane til konfigurasjonsfilen med data om fargeblandingsmaskinen."
            },
            none: {
                machineType: "Det er ikke valgt noen dispenserdriver."
            },
            santintColorLink3: {
                machineType: "Gjelder for alle Santint-maskiner. Kun Windows."
            },
            simulation: {
                machineType:
                    "Gyldig til simulering av fargeblandingsmaskin hvis ingen reell fargeblandingsmaskin er tilkoblet datamaskinen.",
                path: "Bane til simuleringskonfigurasjonsfilen som skal samsvare med den innsatte databasen."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "Oversikten over ytterligere programvaretillegg.",
            allowAutoCloseTab:
                "NÃ¥r innstillingen er aktivert, lukkes hver reseptfane automatisk etter at doseringprosessen er fullfÃ¸rt.",
            allowAutomaticClientStart:
                "NÃ¥r denne innstillingen er aktivert, starter %{name} automatisk etter oppstart av datamaskinen.",
            allowAutomaticPrint:
                "Etiketten skrives ut automatisk. Krever ytterligere innstilling av utskrift fÃ¸r fargeblanding, etter fargeblanding eller begge deler.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "PÃ¥ oppskriftspanelet vil kundedelen vÃ¦re tilgjengelig.",
            allowDispensing:
                "PÃ¥ oppskriftspanelet aktiveres fargeblandingsknappen sammen med innstillingene for fargeblandingsmaskinen i maskininnstillingene.",
            allowFileTransfer:
                "Med denne innstillingen pÃ¥, er automatisk dataimport og eksport ved filoverfÃ¸ring tilgjengelig.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "PÃ¥ formelpanelet vil statuspanelet bli aktivert.",
            allowLight: "%{name} vil bli tilgjengelig.",
            allowOrdering: "PÃ¥ oppskriftspanelet aktiveres ordreknappen.",
            allowPricing:
                "Prisene kan brukes pÃ¥ oppskriftspanelet. Prisenes synlighet er angitt i tilgjengelige priser. Prisene er angitt i prisinnstillingene.",
            allowProductPreviewImage: "Produktbildet vil bli vist under fargeblandingen",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors:
                "PÃ¥ formelpanelet vil funksjonen for Ã¥ sÃ¸ke etter billigere farger vÃ¦re tilgjengelig.",
            allowSoundNotification: "Ordrevarsling. En melodi vil bli avspilt nÃ¥r en ordre mottas.",
            allowSpectro: "Spektrometer",
            allowTabs: "NÃ¥r denne innstillingen er aktivert, er det mulig Ã¥ jobbe med flere faner samtidig.",
            applyZoom: "Zoom forstÃ¸rrer eller reduserer opplÃ¸sningen. Tastatursnarvei CTRL + og CTRL - gjelder ogsÃ¥.",
            automaticLogout: "Angi etter hvor mange minutter den automatiske avloggingen skal aktiveres.",
            availableDatabases:
                "Innstillingene gjÃ¸r det mulig Ã¥ bytte mellom databaser hvis der er flere enn Ã©n tilgjengelig.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Strekkodetesten brukes til Ã¥ kontrollere om den skannede strekkoden er riktig ved Ã¥ sammenligne den med strekkodene som er lagt inn i databasen.",
            customBanner: "Still inn egen logo eller banner og plassering.",
            customCurrencyFormat:
                "Egendefinert valutaformat kan overstyre standardvalutaformatet basert pÃ¥ valgt sprÃ¥k.",
            customDateFormat: "Egendefinert datoformat kan overstyre standard datoformat basert pÃ¥ valgt sprÃ¥k.",
            customNumberFormat: "Egendefinert tallformat kan overstyre standard tallformat basert pÃ¥ valgt sprÃ¥k.",
            customTimeFormat: "Egendefinert tidsformat kan overstyre standard tidsformat basert pÃ¥ valgt sprÃ¥k.",
            defaultPrinter:
                "Den valgte skriveren brukes nÃ¥r du skriver ut etiketter, med mindre dette endres i vinduet for skriverinnstillinger.",
            defaultTemplate:
                "Den valgte malen brukes nÃ¥r du skriver ut etiketter, med mindre dette endres i vinduet for skriverinnstillinger.",
            deleteImportedData:
                "Slett tidligere importerte spesialfremstilte data. Dataene kan importeres igjen etter sletting.",
            diskSpaceNotification: "Kontrollerer tilgjengelig diskplass og varsler ved utilstrekkelig plass.",
            dispensingNotes: "PÃ¥ oppskriftspanelet er avsnittet om fargeblandingsnotater tilgjengelig.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "I %{name} er det virtuelle tastaturet tilgjengelig.",
            exportLocalSettings: "Eksporterer de lokale innstillingene pÃ¥ denne datamaskinen.",
            exportStaticSql:
                "Eksporterer de lokale innstillingene pÃ¥ denne datamaskinen. Den eksporterte filen kan brukes til Ã¥ opprette en database med de samme innstillingene.",
            exportTranslationKeys:
                "Eksporter de nyeste oversettelsene, og send dem pÃ¥ e-post til programvareleverandÃ¸ren etter oversettelsen for Ã¥ fÃ¥ dem importert.",
            favoriteButton: "Klikk her for Ã¥ legge til resept som favoritt",
            formulaNotes: "PÃ¥ oppskriftspanelet er delen med oppskriftsnotater tilgjengelig.",
            helpSettings: "Opplysningene er synlige i delen om hjelp pÃ¥ panelet med hurtigtilgang.",
            importCustomData: "Importerer lokale spesiallagede data basert pÃ¥ det valgte formatet.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Importer de lokale innstillingene pÃ¥ denne datamaskinen.",
            internalNote: "PÃ¥ Formel -panelet vil den interne notatdelen vÃ¦re tilgjengelig.",
            lockComputer:
                "Innstillingene sikrer at omgivelsene for %{name} ikke kan bli liggende â det gir den ultimate opplevelsen av programmet i fullskjerm. Gjelder kun Windows.",
            maxNumberTabs: "Fanebegrensningen angir hvor mange oppskriftsfaner som kan Ã¥pnes samtidig.",
            memoryTabs: "Tillat gjenÃ¥pning av nylig Ã¥pnede faner etter at programvaren starter.",
            printAfterDispensing:
                "Innstillingen krever informasjon om hvor mange etikettkopier som skal skrives ut etter fargeblandingsprosessen.",
            printAsImage:
                "Utskrift som bilde bidrar til Ã¥ lÃ¸se problemene nÃ¥r standardutskrift mislykkes. Dette skal ikke brukes nÃ¥r standardutskriften fungerer korrekt. Kun kompatibel med Linux.",
            printBeforeDispensing:
                "Innstillingen krever informasjon om hvor mange etikettkopier som skal skrives ut fÃ¸r fargeblandingsprosessen.",
            printEnabled:
                "Med denne innstillingen kan du bruke skriveren sammen med programvaren. Du finner flere innstillinger i Utskriftsinnstillinger.",
            printOnRequest: "PÃ¥ oppskriftspanelet aktiveres utskriftsknappen.",
            printTaskVariable:
                "Utskriftsoppgaven behandles bare hvis en gitt utskriftsvariabel er tilgjengelig i utskriftsdata",
            quickTintTemplate: "Den valgte malen brukes nÃ¥r du skriver ut raske fargeblandingsetiketter.",
            restoreLocalSettings: "Gjenoppretter de lokale innstillingene pÃ¥ denne datamaskinen.",
            runLightAtStartUp: "%{light} startes i stedet for %{name}.",
            screenSaverTimeout: "Angi timeout for pauseskjerm",
            selectCustomDataFormat:
                "Velg formatet for originaldata som skal importeres. Hvert format krever kanskje ulike ekstrafiler og innstillinger.",
            setCustomHomeButton: "Hjem-knappen i %{name} omdirigerer til det valgte panelet.",
            setFts: "FulltekstsÃ¸k gjÃ¸r det mulig Ã¥ sÃ¸ke i oppskrifter i fulltekst (ogsÃ¥ fra midten av ordet osv.).",
            setKeyboardShortcuts:
                "Det er ikke mulig Ã¥ stille inn den samme tastatursnarveien til to forskjellige handlinger.",
            setNumberOfDecimalPlaces:
                "Avrundingen angir hvor mange desimaler tonepastaen som brukes i oppskriftene, vises med.",
            setOrderSearchParameters:
                "OrdresÃ¸k angir hvilke parametere som skal brukes ved sÃ¸k blant ordrer. Kun tilgjengelig i %{name}.",
            setOverwriteLastTab:
                "NÃ¥r du velger en ny oppskrift via globalt sÃ¸k, nÃ¥r oppskriftsfanebegrensningen er nÃ¥dd, overskrives den sist innleste oppskriftsfanen for den nye valgte oppskriften.",
            setSearchPanel:
                "Angi din egen synlighet og rekkefÃ¸lge pÃ¥ de elementene som skal brukes nÃ¥r du sÃ¸ker efter en ny oppskrift.",
            setVisibilityAndOrder:
                "De valgte navigasjonselementene er synlige i panelet med hurtigtilgang. Den hÃ¸yeste posisjonen angir her den venstre posisjonen i panelet. Den maksimalt tillatte mengden navigasjonselementer er 6.",
            setYourLanguage: "SprÃ¥kendring krever omstart av programvare.",
            settingsSearch: "SlÃ¥ opp forskjellige innstillinger hvis du er usikker pÃ¥ hvor du finner dem.",
            showNewOrderNotifications: "Ordremelding er et pop-up-vindu som melder om at en ny ordre er mottatt.",
            sorting:
                "Hurtigfargeblanding kan bestilles i beholderne i henhold til tonepastanavn eller etter kanister-ID-er.",
            turnOnKioskMode: "Fullskjerm er pÃ¥ og skjuler prosesslinjen.",
            windowClosingRules:
                "Innstillingen bestemmer om vinduet med hurtigfargeblanding lukkes fÃ¸r eller etter starten av fargeblandingsprosessen."
        },
        formulaSettings: {
            additionalFormulaTab:
                "Innstillingen bestemmer hvilket panel som vil bli vist nÃ¥r en ny oppskriftsfane Ã¥pnes.",
            allowCustomFormulas: "Fremstilling og sÃ¸k etter spesiallagede oppskrifter vil bli aktivert.",
            allowCustomPackageSize: "PÃ¥ oppskriftspanelet vil spesiallagede pakkestÃ¸rrelser bli aktivert.",
            allowEditingColorants:
                "PÃ¥ oppskriftspanelet vil redigering av tonepastaknappen bli aktivert (synlig etter valg av farge).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Angi stÃ¸rrelsen pÃ¥ basen pÃ¥ Formula -panelet",
            bippPanelSize: "Angi stÃ¸rrelsen pÃ¥ basen i produktpakken pÃ¥ Formula -panelet",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "PÃ¥ oppskriftspanelet vil den eneste synlige informasjonen vÃ¦re fargeeksempelet.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "PÃ¥ Formel -panelet vil forhÃ¥ndsvisningen av farger bli representert av bildet.",
            colorPreviewResizable: "Tillater Ã¥ endre stÃ¸rrelsen pÃ¥ forhÃ¥ndsvisningspanelet for farger.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy:
                "Formelpanelet kan ha fargestoffene bestilt i henhold til navnene eller etter mengder.",
            customCanOption:
                "Velg hvilke mÃ¥leenheter som kan brukes for tilpasset pakningsstÃ¸rrelse pÃ¥ Formel -panelet.",
            customCanSettingsUnit:
                "Velg hvilken mÃ¥leenhet som kan brukes som standard for egendefinerte pakkeinnstillinger pÃ¥ Formel -panelet.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Aktivering av denne innstillingen fÃ¸rer til at popup-vinduer bekrefter sletting av et element.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Angi stÃ¸rrelsen pÃ¥ fandeck pÃ¥ formelruten",
            favoriteFormulasInitial: "NÃ¥r du starter %{name}, vises favorittpanelet.",
            formulaAutomaticNaming:
                "En endret oppskrift fÃ¥r navn automatisk basert pÃ¥ de utfÃ¸rte tonepastamodifikasjonene.",
            formulaPanel: "NÃ¥r du Ã¥pner en ny fane, vises oppskriftspanelet.",
            formulaPanelInitial: "NÃ¥r du starter %{name}, vises oppskriftspanelet.",
            formulaPanelSize: "Angi stÃ¸rrelsen pÃ¥ formelen pÃ¥ formulapanelet",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "Med denne innstillingen pÃ¥, vil forhÃ¥ndsvisningen av farger genereres automatisk. ForhÃ¥ndsvisningsresultatet er ikke nÃ¸yaktig.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "PÃ¥ oppskriftspanelet vil produktbildet vÃ¦re synlig ved siden av fargeeksempelet med mulighet for Ã¥ Ã¥pne panelet med mer info.",
            images: "Innstillingen definerer kilden til bildefiler.",
            infoPanelResizable: "Tillater Ã¥ endre stÃ¸rrelsen pÃ¥ mer infopanel.",
            initialFormulaTab: "Innstillingen bestemmer hvilket panel som vises, nÃ¥r %{0} starter.",
            moreInfo:
                "PÃ¥ oppskriftspanelet vil informasjonspanelet vÃ¦re synlig ved siden av fargeeksempel og produktbilde.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "Med denne innstillingen kan du bruke produktkoder sammen med produktnavn hvis informasjonen er tilgjengelig i databasen.",
            productFiles: "Innstillingen definerer kilden til produktfiler som er tilgjengelige pÃ¥ formelpanelet.",
            productGroups: "Innstillingen muliggjÃ¸r hierarki med produktgrupper hvis den er tilgjengelig i databasen.",
            productPanelSize: "Angi stÃ¸rrelsen pÃ¥ produktet pÃ¥ Formula -panelet",
            searchNewFormula:
                "NÃ¥r du Ã¥pner en ny fane, vises SÃ¸k etter oppskrift (inneholder opplysninger om sist fargeblandet oppskrift og favorittoppskrifter).",
            searchNewFormulaInitial:
                "NÃ¥r du starter %{name}, vises SÃ¸k etter oppskrift (inneholder opplysninger om sist fargeblandet oppskrift og favorittoppskrifter).",
            searchPanelFormulaItems: "Minst ett av formelproktene mÃ¥ velges.",
            searchPanelProductItems: "Bare ett av produktelementene kan velges.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "PÃ¥ oppskriftspanelet vil den valgte datatypen alltid vÃ¦re synlig i fargeeksemplet.",
            setFormulaPreview:
                "Innstillingen endrer plasseringen og visningen av fargeeksempel, pakkebilde og infodata om fargen.",
            setFormulaRGBPreviewVisibleInformation:
                "PÃ¥ oppskriftspanelet vil den valgte datatypen alltid vÃ¦re synlig i fargeeksemplet.",
            setFormulaUnit:
                "PÃ¥ oppskriftspanelet bestemmer denne innstillingen hvilken fargeenhet som skal Ã¥pnes fÃ¸rst etter valg av en farge. Gjelder ogsÃ¥ i hurtigfargetoner.",
            setFormulaVisibilityAndOrder:
                "PÃ¥ oppskriftspanelet vil de valgte data vÃ¦re synlige i avsnittet Mer info (gjelder bare hvis oppskriftseksempelet under oppskriftsinnstillingen er satt til Bilde eller Mer info.)",
            setMaxToleranceForCompetitiveColors:
                "Still inn maksimal Delta E (CIE 2000)-toleranse til simulerende fargesÃ¸k.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "PÃ¥ oppskriftspanelet bestemmer denne innstilling hvilke tonepastaer som er synlige nÃ¥r du har valgt en farge. Gjelder ogsÃ¥ i hurtigfargetoner.",
            showColorPreview:
                "PÃ¥ oppskriftspanelet vises smÃ¥ fargeeksempler ved siden av fargenavnet nÃ¥r du sÃ¸ker etter en ny oppskrift.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Summen av mengder fargestoffer er under basisgrensen.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "Den minimale brekkbare mengden er den minste mengden fargestoff som kan doseres som anbefalt av laboratoriet.",
            checkOverfill:
                "Innstillingen sjekker om det er nok plass i boksen for fargestoffene umiddelbart etter at mengdene er angitt.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Fargemengden er under den minimale tonbare mengden.",
            dispensingWithErrorsEnabled:
                "Hvis det er tillatt, vil en advarsel vises i tilfelle brudd pÃ¥ validering, men det vil vÃ¦re mulig Ã¥ fortsette til toning.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Summen av mengder fargestoffer er over maksimal tonbare mengder.",
            overfill: "Overfylling er oppdaget.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Jeg skjÃ¸nner risikoen, fortsett"
        },
        help: "Hjelp",
        helpLink: "Hjelpesentral",
        helper: {
            automaticallyCheckForUpdates:
                "Det kontrolleres automatisk om det finnes en tilgjengelig oppdatering for %{name} eller database i det angitte tidsintervallet.",
            automaticallyDownloadUpdates:
                "Hvis en oppdatering er tilgjengelig, lastes den automatisk ned uten bekreftelse.",
            automaticallyInstallNewDatabases:
                "Hvis en hittil fravÃ¦rende DB er sendt, blir den installert som en ny DB. EtterpÃ¥ kan DB brukes.",
            automaticallyInstallUpdates:
                "Hvis en oppdatering er nedlastet, installeres den automatisk uten bekreftelse.",
            canBrowseChangeLog: "Ved oppdatering av programvaren er en offisiell %{name} endringslogg tilgjengelig",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "Oppdateringen installeres om natten hvis datamaskinen er slÃ¥tt pÃ¥."
        },
        licensing: {
            collect:
                "Loggfilene lastes ned til valgt plassering. Loggfilene kreves av programvareleverandÃ¸ren for Ã¥ levere feilanalyse.",
            company: "Selskapet som leverte lisensen.",
            computerID: "Lisensidentifisering for Ã¥ hjelpe programvareleverandÃ¸ren dersom hjelp er nÃ¸dvendig.",
            email: "Lisensinnehaverens e-post-adresse.",
            licenseUuid: "Lisensidentifisering for Ã¥ hjelpe programvareleverandÃ¸ren dersom hjelp er nÃ¸dvendig.",
            name: "Navnet pÃ¥ lisensinnehaveren.",
            openBugreport: "Gi beskjed om det er en feil i programvaren, og send oss en rapport med feilbeskrivelsen.",
            posInfoContactperson: "Salgsstedsopplysninger om eieren som skal skrives pÃ¥ etiketten.",
            posInfoMachineInformation:
                "Salgsstedsinformasjon om dispenseren som skal skrives pÃ¥ etiketten eller gjenkjennes i nettverket.",
            posInfoPos: "Salgsstedsopplysninger om stedet som skal skrives pÃ¥ etiketten.",
            reactivation: "Ny aktivering eller endring av den aktuelle lisensen.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registreringsopplysninger for Ã¥ identifisere eieren av lisensen.",
            registrationMachineInformation:
                "Registreringsinformasjon for Ã¥ identifisere fargeblandingsmaskinen opp mot lisensen.",
            registrationPos: "Registreringsopplysninger for Ã¥ identifisere lisensplassering.",
            versionScope: "Programvarens utlÃ¸psgrenser.",
            versionType: "Programvareprodukttype."
        },
        machineIsBusy: "Feil kan ikke nullstilles, fordi maskinen er opptatt.",
        machineSettings: {
            allowManualColorantAddition:
                "Hvis tonepastamengden som kreves overstiger den maksimale doseringsmengden, gjÃ¸r innstillingen det mulig Ã¥ legge den til manuelt etter fargeblandingen.",
            autotasks:
                "Autotask er automatiske vedlikeholdelsehendelser for maskinen og datamaskinen som kan stilles inn til Ã¥ bli utfÃ¸rt pÃ¥ et bestemt tidspunkt eller tidsintervall.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "Strekkoden tildeles kanisteren der tonepastaen er tilgjengelig. Strekkoden er nÃ¸dvendig for Ã¥ sikre korrekt pÃ¥fylling av tonepasta.",
            checkCanBeforeDispense:
                "Maskinkonfigurasjonen sammenlignes med databasen hver gang RCC (Redlike Control Center) startes pÃ¥ nytt. Ved uoverensstemmelser vises en melding.",
            checkOverfill:
                "Innstillingen kontrollerer om det er nok plass i boksen/spannet til tonepastaene fÃ¸r utlevering.",
            currentlySelectedMachine: "Inneholder informasjon om den aktuelle valgte maskinen.",
            dispenseInvalidColorants:
                "Innstillingen gjÃ¸r det mulig Ã¥ dosere tonepastaer som ikke er definert i maskinkonfigurasjonen ved Ã¥ be om at tonepasta legges til manuelt.",
            dispenserConfigurationBackup:
                "Last ned og lagre den aktuelle maskinkonfigurasjonen for Ã¥ opprettholde en sikkerhetskopi.",
            dispensingLogic:
                "Dispenseringslogikktyper kan sikre ulik atferd for hver kanister nÃ¥r det er mer tonepasta som skal utleveres enn det som er tillatt eller Ã¸nsket. Annen atferd kan stilles inn i dispenseringsinnstillingene.",
            enableTmc: "Denne innstillingen gjÃ¸r det mulig Ã¥ sende data til TMC.",
            enableUserIdentification: "Brukeren mÃ¥ logge pÃ¥ fÃ¸r toning er tillatt.",
            machineUnit: "Maskinenheten definerer mÃ¥leenheten for tonepastaene i kanisterne.",
            minDispensedAmount:
                "Minste doseringsmengde angir hvor mye tonepasta skal ha vÃ¦rt dosert for Ã¥ vurdere rensing (for Ã¥ unngÃ¥ ytterligere rensing).",
            minimalDispenseAmount:
                "Minimal doseringsmengde er den minste anbefalte mengden tonepasta som kan doseres. Hvis den overskrides, vises en melding (dosering er fortsatt mulig).",
            missingAutotaskCanisters: "Velg minst 1 kanister",
            missingAutotaskChannels: "Velg minst 1 kanal",
            missingAutotaskChannelsValue: "Volum for alle valgte kanaler mÃ¥ utfylles",
            missingAutotaskCleanTime: "RengjÃ¸ringstidspunktet mÃ¥ utfylles",
            missingAutotaskName: "Navnet pÃ¥ autotask mÃ¥ utfylles",
            missingAutotaskRecirculation: "Tid og hastighet for resirkulasjon mÃ¥ utfylles",
            missingAutotaskStirring: "Tid og hastighet for rÃ¸ring mÃ¥ utfylles",
            missingAutotaskVolume: "Rensevolum mÃ¥ utfylles",
            placeCanSensor:
                "Innstillingen aktiverer sensor til boksplassering â fargeblanding starter ikke hvis ikke boksen/spannet er plassert korrekt.",
            placeCanSensorDelay:
                "Anbefalt innstilling som er knyttet til sensor. Det sikrer at doseringen fÃ¸rst starter etter den angitte tidsperioden der boksen/spannet ble korrekt plassert.",
            purgeVolume: "Rensevolumet stiller inn hvor mye tonepasta som skal renses ved smart rensing.",
            rccUrl: "RCC (Redlike Control Center) er ansvarlig for kommunikasjonen med fargeblandingsmaskinen.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Innstillingen aktiverer sensoren til boksuttak â fargeblandingen anses ikke som utfÃ¸rt, hvis ikke boksen er blitt fjernet.",
            removeCanSensorDelay:
                "Anbefalt innstilling som er knyttet til sensor for boksfjerning. Det sikrer at fargeblandingen fÃ¸rst er avsluttet etter den angitte perioden der boksen er blitt fjernet.",
            skipPlaceCanDialog:
                "NÃ¥r denne innstillingen er aktivert, vil ikke fargeblandingsmaskinen vente pÃ¥ at OK-knappen skal trykkes inn nÃ¥r en boks blir plassert, men starter fargeblandingsprosessen automatisk.",
            skipRemoveCanDialog:
                "NÃ¥r denne innstillingen er aktivert, vil ikke fargeblandingsmaskinen vente pÃ¥ at OK-knappen skal trykkes inn nÃ¥r en boks blir plassert, men vil automatisk vurdere fargeblandingsprosessen som avsluttet.",
            smartPurgeType:
                "Rensetypen kan enten vurdere kun dosering eller dosering i tillegg til andre rensehendelser, ved validering, hvis det er behov for smart rensing.",
            splitFormula:
                "Hvis den pÃ¥krevde mengden tonepasta overstiger den maksimale doseringsmengden, gir innstillingen mulighet for Ã¥ dosere en mengde tonepasta, fylle pÃ¥ beholderen og deretter fortsette med Ã¥ dosere resten.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Basen skal valideres via strekkode fÃ¸r fargeblanding er tillatt. Innstillingen sikrer at korrekt base brukes.",
            validateColorantsDuringInit:
                "Maskinkonfigurasjonen sammenlignes med databasen hver gang RCC startes pÃ¥ nytt. Ved uoverensstemmelser oppstÃ¥r det en melding."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Ãpner et vindu med mulighet for Ã¥ angi strekkoden manuelt.",
            canisterBarcodes:
                "Ãpner et vindu med oversikt over kanisternes strekkoder og muligheten for Ã¥ stille inn strekkodene for kanisterne.",
            canisterLevel:
                "Ãpner et vindu med oversikt over kanisternivÃ¥er og muligheten for Ã¥ stille inn kanisternivÃ¥et.",
            canisters: "Ãpner et panel med oversikt over kanisternivÃ¥er og muligheten for Ã¥ stille inn kanisternivÃ¥et.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Ãpner et panel med mulighet for Ã¥ sÃ¸ke etter en ny oppskrift i et elektronisk fargekart.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Ãpner et vindu med oversikt over utfÃ¸rte kanisterpÃ¥fyllinger.",
            customFormula: "Ãpner et panel med mulighet for Ã¥ opprette en ny spesialfargeblanding",
            customers:
                "Ãpner et panel med oversikt over kunder og muligheten for Ã¥ legge til / redigere / slette kunder.",
            dispensingHistory: "Ãpner et panel med oversikt over utfÃ¸rte fargeblandinger.",
            favorites: "Ãpner et panel med mulighet for Ã¥ velge favorittoppskrifter.",
            help: "Ãpner et vindu med kundeserviceopplysninger hvis leverandÃ¸ren har levert slike.",
            hideItems: "Ãpner et vindu med mulighet for Ã¥ merke produkter og fandecks som skjulte.",
            historyOfOrders: "Gjelder utelukkende for %{name}, Ã¥pner et panel med oversikt over fargeblandingsordrer.",
            machineReset: "Starter nullstilling av fargeblandingsmaskin.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Ãpner et panel med oversikten over sendte ordrer.",
            purge: "Ãpner et vindu med mulighet for Ã¥ stille inn kanisterrensing.",
            quickTint: "Ãpner et vindu med mulighet for manuell fargeblanding.",
            searchFormula: "Ãpner et panel med mulighet for Ã¥ sÃ¸ke etter en ny oppskrift.",
            spectro: "Ãpner et panel med mulighet for Ã¥ mÃ¥le med et spektrometer.",
            stir: "Ãpner et vindu med mulighet for Ã¥ stille inn beholderrÃ¸ring.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Ãpner et panel med oversikten over mottatte ordrer."
        },
        noHelpForLicense: "Det finnes ingen hjelp tilgjengelig for din lisens, be leverandÃ¸ren om Ã¥ legge til dette.",
        posInfo: {
            sync: "Synkroniserer data med avsnittet om registrering"
        },
        poweredByDeso: "Drevet av %{name}",
        priceSettings: {
            VatPrice: "Momsverdi for tonepasta i %.",
            VatPriceProduct: "Mva. pÃ¥ produktet er den samme for alle tonepastaer. Angitt i %.",
            basePurchase: "KjÃ¸pspris for base (inkl. base utelukkende).",
            basePurchasePriceProduct: "KjÃ¸sprisen for produktet i den gitte basen. Angitt i valgt valuta.",
            baseSell: "Salgsprisen kun for base (inkl. base og profitt (margin)/Ã¸nsket profittprosent (markup).",
            baseSellFull: "Sell full price for base.",
            cntName: "Definerer hvilken tonepasta prisen er knyttet til.",
            cntPurchase: "KjÃ¸pspris for tonepastaer (inkl. tonepastaer utelukkende).",
            cntPurchaseByName: "KjÃ¸pspris for tonepastaer beregnet individuelt for hver (inkl. tonepasta utelukkende).",
            cntPurchasePricePerLiter:
                "Kostpris for tonepasta pr. liter (uten profitt (margin) eller Ã¸nsket profittprosent (markup)).",
            cntSell:
                "Salgsprisen kun for tonepasta (inkl. tonepastaer og profitt (margin)/Ã¸nsket profittprosent (markup)).",
            cntSellByName:
                "Salgsprisen for alle de anvendte tonepastaene beregnet individuelt for hver (inkl. tonepasta og profitt (margin)/Ã¸nsket profittprosent (markup)).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "Salgsprisen for brekkfargen per liter (inkl. tonefarge eksklusivt). Angi i valgt valuta.",
            cntVat: "Mva. for tonepasta angitt i %.",
            colorants:
                "De generelle prisene for tonepasta er de samme for alle tonepastaer. Denne funksjonen er spesielt nyttig til innstilling av moms.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Valutakoden skal ha et offisielt trebokstaversformat, for eksempel EUR.",
            currencyNameNew: "Navnet pÃ¥ valutaen, for eksempel euro.",
            currencyRateNew:
                "Valutakursen mod hovedvalutaen, for eksempel 25,855 CZK for 1 â¬. Satsen skal redigeres lÃ¸pende for Ã¥ holdes oppdatert.",
            currencyRoundingNew:
                "Avrunding stiller inn den minste mulige verdien av valutaen. For eksempel har euro avrundingen 0,01, fordi den minste mulige verdien er 1 cent.",
            currencySymbolNew: "Det offisielle symbolet pÃ¥ valutaen, for eksempel â¬ for euro.",
            defaultPrice: "Tonepastapris angitt i den valgte databasen (uten moms).",
            defaultPriceGroup: "Tonepastapris for prisgruppe innstilt i den valgte databasen (uten moms).",
            defaultVatPrice: "Moms for tonepasta angitt i den valgte databasen.",
            discountHeader: "Rabatten trekker den definerte verdien fra kjÃ¸psprisen pÃ¥ tonepasta. Angitt i %.",
            discountHeaderProduct: "Rabatten trekker den definerte verdien fra prisen pÃ¥ tonepasta. Angitt i %.",
            export: "Eksporter en fil med de aktuelt innsatte prisene. Den kan importeres pÃ¥ nytt etter Ã¥ ha endret prisene.",
            import: "Importer en korrekt formatert (eksportert) fil for Ã¥ sette inn endre prisene.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Velg hvilken prisberegning som skal brukes til definisjonen av den endelige prisen. Margin og pÃ¥slagstall legges til mens rabatten trekkes fra den angitte salgsprisen.",
            marginAll:
                "Prisen for profitt (margin)/Ã¸nsket profittprosent (markup) for flere pakker (inkl. margin/markup).",
            marginHeader: "Margin legger den definerte verdien til kjÃ¸psprisen for tonepasta. Angitt i %.",
            marginHeaderProduct: "Margin legger den definerte verdien til kjÃ¸psprisen for produktet. Angitt i %.",
            marginPerPkg:
                "Prisen for profitt (margin)/Ã¸nsket profittprosent (markup) for en pakke (inkl. margin/markup).",
            markupHeader: "PÃ¥slagstall legger den definerte verdien til kjÃ¸psprisen for tonepasta. Angitt i %.",
            markupHeaderProduct: "PÃ¥slagstall legger den definerte verdien til kjÃ¸psprisen for produktet. Angitt i %.",
            packagePricing: "Ekstratillegg angitt individuelt for hver pakkestÃ¸rrelse.",
            packageSurcharge: "De generelle pakkeprisene er de samme for hvert pakketillegg.",
            priceDefinition: "Innstillingen definerer hvilke pristyper som brukes ved beregning av sluttpriser.",
            priceGroupNumber:
                "Innstillingen definerer hvor mange prisgrupper som skal brukes. Intervallet for individuelle prisgrupper kan angis i Standardverdier.",
            priceGroupPricePerLiter: "Tonepastaprisen som brukes til beregning av prisgruppeprisen.",
            priceGroups:
                "Prisgrupper viser nummeret pÃ¥ den relevante prisgruppen (grensene er angitt i databasen eller i generell prisbestemmelse).",
            priceGroupsEnabled:
                "Innstillingen lar deg jobbe med prisgrupper. Definer omrÃ¥det i standardverdier og individuelle priser i tonefargepriser.",
            priceGroupsGeneric:
                "Prisgrupper er prisintervaller for den endelige malingen basert pÃ¥ tonepastaen i oppskriften.",
            productBasePackageSellPrice: "Salgspris for pakken til den gitte basen. Sett i valgt valuta.",
            productBaseSellPrice: "Salgspris for base beregnet per liter (inkl. eksklusiv base). Angi i valgt valuta.",
            productBaseVat: "Mva.-verdien for den angitte pakken er angitt i %.",
            productName: "Definerer hvilken base av hvilket produkt prisen er knyttet til.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "KjÃ¸psprisen for alle pakker brukes ved dispensering av brukerdefinerte pakker.",
            productSize: "Definerer hvilken pakke av den angitte basen og produktet prisen er knyttet til.",
            productVat: "Merverdiavgift for denne produktbasen angitt i %.",
            products:
                "De generelle pakkeprisene er de samme for hvert produkt. Denne funksjonen er spesielt nyttig til innstilling av moms.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "Salgsprisen for flere pakker (inkl. base, tonepasta tillegg og profitt (margin) / Ã¸nsket profittprosent for flere pakker (markup).",
            sellPricePerKg:
                "Produktets salgspris pr. kg (inkl. base, tonepasta, tillegg og profitt (margin) / Ã¸nsket profittprosent (markup)).",
            sellPricePerL:
                "Produktets salgspris pr. liter (inkl. base, tonepasta, tillegg og profitt (margin) / Ã¸nsket profittprosent (markup)).",
            sellPricePerPkg:
                "Salgsprisen for en pakker (inkl. base, tonepasta, tillegg og profitt (margin) / Ã¸nsket profittprosent (markup)).",
            setPriceTypesVisibilityAndOrder:
                "I oppskriftspanelet vil de valgte prisene vÃ¦re synlige i avsnittet om priser. Den hÃ¸yeste posisjonen her angir posisjonen lengst til venstre i seksjonen.",
            surchargeAll: "Prisen pÃ¥ et tilleggsgebyr for flere pakker (inkl. tillegg).",
            surchargePerPkg: "Prisen pÃ¥ et tilleggsgebyr for en pakke (inkl. tillegg).",
            tintPurchaseAll:
                "KjÃ¸psprisen for hele fargeblandingsprosessen for flere pakker (inkl. tonepasta og tillegg).",
            tintPurchasePerPkg:
                "KjÃ¸psprisen for hele fargeblandingsprosessen for en pakke (inkl. tonepasta og tillegg).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "Den samlede kjÃ¸psprisen for produktet for flere pakker (inkl. base og tonepastaer).",
            totalPurchasePerKg: "Den samlede kjÃ¸pspris for produktet pr. kg (inkl. base og tonepastaer).",
            totalPurchasePerL: "Den samlede kjÃ¸psprisen for produktet pr. liter (inkl. base og tonepastaer).",
            totalPurchasePerPkg: "Den samlede kjÃ¸psprisen for produktet for en pakke (inkl. base og tonepastaer).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "PÃ¥ oppskriftspanelet vil prisen vÃ¦re synlig i begge varianter, med og uten moms, samtidig.",
            withVat: "PÃ¥ oppskriftspanelet er alle priser kun synlige med moms inkludert.",
            withoutVat: "PÃ¥ oppskriftspanelet vil alle priser kun vÃ¦re synlige uten moms."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Synkroniserer data med avsnittet POS-info"
        },
        searchingPleaseWait: "Vennligst vent, den beste matchen sÃ¸kes",
        setupSteps: {
            customData: "Spesiallagde data",
            machineType: "Maskintype",
            userPreferences: "Brukerpreferanser "
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "NÃ¥r du bruker profilerte verdier, beregnes de mÃ¥lte resultatene pÃ¥ nytt for Ã¥ fjerne filtereffekten. Tillat Ã¥ bruke denne innstillingen til universell spektromÃ¥ling.",
            XRiteModelRM400: "Ingen drivere kreves.",
            datacolorDiagnosticTile: "Datafarge bruker diagnostisk flis",
            datacolorSilent: "Datafarge taus",
            measureModes: "Velg stÃ¸ttede glansnivÃ¥er.",
            model: "Modell",
            simulationPath: "Simuleringsbane",
            spectroType: "Spektrometertype",
            spectroTypeCom: "Offisiell spektrodriver skal installeres. Pass pÃ¥ anvendt COM-port. Windows samt Linux.",
            spectroTypeDataColorReader:
                "Datamaskinen skal have Bluetooth-tilkobling. Spektroen skal pares med datamaskinen. Krever Windows 10 med 2018 hÃ¸stoppdatering.",
            spectroTypeMinolta2XXXd:
                "Offisiell spektrodriver skal installeres. Pass pÃ¥ anvendt COM-port. Windows samt Linux.",
            spectroTypeNotSelected: "Velg spektromodell.",
            spectroTypeRM400: "Ingen drivere kreves.",
            spectroTypeSimulation:
                "Laboratorieverdier som kreves for Ã¥ oppnÃ¥ simuleringsresultater. Windows samt Linux.",
            spectroTypeXRite: "Kun i Windows."
        },
        ufiCode: {
            baseUfiCodeValidation: "UFI -koden til basen kan valideres via strekkode fÃ¸r toning tillates",
            enableUfiCodes: "UFI -koder brukes i EU og gir informasjon om hvor farlig et produkt er for miljÃ¸et.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Hvis et fargestoff i en formel overskrider den gitte grensen, skrives UFI -koden ut pÃ¥ utskriftsetiketten.",
            printUfiCodePercentage:
                "Hvis et fargestoff i en formel overskrider den gitte grensen, skrives UFI -koden ut pÃ¥ etiketten sammen med prosentvis representasjon.",
            ufiCodesByPercentage:
                "UFI -koden som rÃ¥der, brukes til utskrift med tanke pÃ¥ den faktiske mengden i beholderen. Naviger til beholderinnstillinger for Ã¥ definere terskelen for hver beholder.",
            ufiCodesFromDatabase: "UFI -koden fra hoveddatabasen gitt av databaseadministratoren brukes til utskrift.",
            ufiCodesFromLastFilling:
                "UFI -koden fra den siste pÃ¥fyllingen som ble gitt av operatÃ¸ren, brukes til utskrift uansett pÃ¥fylt mengde."
        },
        userManagement: {
            add: "Innstillingen legger til en ny bruker som kan logge inn pÃ¥ programvaren. Brukeren kan fÃ¥ tildelt en strekkode, og automatisk pÃ¥logging kan stilles inn etter at programvaren har startet.",
            assignedGroups:
                "Dette angir hvilke brukergrupper brukeren tilhÃ¸rer. Ulike brukergrupper har ulike privilegier.",
            availableGroups:
                "Dette angir hvilke brukergrupper som er tilgjengelige for brukeren. Ulike brukergrupper har ulike privilegier.",
            loggedUserDelete: "Brukeren som er logget pÃ¥, kan ikke slettes."
        },
        visit: "Eller gÃ¥ til",
        visitNoLicense: "Du finner mer informasjon pÃ¥"
    },
    helpSettings: {
        customHelpLink: "Standardisert lenke til hjelpesenter",
        helpSettings: "Innstillinger for hjelp",
        message: "Beskjed"
    },
    helper: {
        automaticallyCheckForUpdates: "Sjekk automatisk for oppdateringer",
        automaticallyDownloadUpdates: "Last ned oppdateringer automatisk",
        automaticallyInstallNewDatabases: "Installer nye DB-er automatisk",
        automaticallyInstallUpdates: "Installer oppdateringer automatisk",
        bugReport: "Programvarefeilrapport",
        canBrowseChangeLog: "Vis online %{name} endringslogg",
        collect: "Samle",
        collectLogFiles: "Samle loggfiler",
        component: "Komponent",
        content: "Innhold",
        contentSize: "InnholdsstÃ¸rrelse",
        download: "Last ned",
        downloadLogFiles: "Last ned loggfiler",
        downloadingData: "Laster ned data",
        everyHours: "Hver %{interval} time",
        forceInstall: "Force to update",
        installDuringNight: "Om natten (23:00â05:00)",
        newVersion: "Ny versjon",
        notConnected: "Hjelper er ikke tilkoblet",
        openBugReport: "Ãpen feilrapport",
        packageSize: "PakkestÃ¸rrelse",
        pleaseWait: "Dette kan ta litt tid, vennligst vent.",
        send: "Send",
        sendBugReportToCustomerService: "Send feilrapport",
        sendingReport: "Sender",
        subject: "Emne"
    },
    helperDialog: {
        1: "Du kan kontrollere programvare- eller databaseoppdateringer.",
        2: "Vil du fortsette med Ã¥ laste ned oppdateringspakkene?",
        3: "Vil du fortsette med installeringen av nedlastede oppdateringspakker?",
        10: "Kontrollerer programvare- og databaseoppdateringer, vent litt ...",
        11: "Det er en oppdatering tilgjengelig pÃ¥ din datamaskin. Vil du laste den ned?",
        12: "Der finnes ingen tilgjengelige oppdateringer for din datamaskin.",
        14: "Det oppsto en feil under kontroll av oppdateringer. %{0}",
        15: "Synkroniserer sonedatabaser, vent litt ...",
        20: "Laster ned oppdateringspakke, vent littÂ ...",
        21: "Oppdateringspakke som ble nedlastet verifiseres nÃ¥. Vent litt ...",
        22: "Nedlasting av oppdateringspakken mislyktes. Vil du prÃ¸ve igjen?",
        23: "Nedlasting av oppdateringspakken mislyktes (filen er feilformatert), vil du prÃ¸ve igjen?",
        24: "Vil du fortsette med oppdateringsinstallasjonen?",
        25: "Installeringen av automatisk oppdatering starter om %{0}",
        26: "Det er en oppdatering tilgjengelig pÃ¥ din datamaskin. Vil du laste den ned?",
        27: "Vil du fortsette med oppdateringsinstallasjonen?",
        40: "Stanser applikasjoner og tjenester, vent litt ...",
        41: "Kopierer nye filer, vent litt ...",
        42: "Starter applikasjoner og tjenester, vent litt ...",
        43: "Avslutt programvareoppdatering, vent litt ...",
        44: "Programvaren er blitt oppdatert.",
        45: "Vil du prÃ¸ve installering pÃ¥ nytt? Hvis du bestemmer deg for Ã¥ prÃ¸ve igjen, mÃ¥ du sikre at programvarekomponenter ikke er i bruk for Ã¸yeblikket.",
        46: "Omstart av PC kreves for Ã¥ pÃ¥virke endringene, omstart skjer i %{0}",
        999: "Intern feil oppsto: %{0}",
        automaticInstallation: "Installering av automatisk oppdatering",
        btnAbort: "Avbryt",
        btnCancel: "Annuller",
        btnCheckUpdate: "SÃ¸k etter oppdateringer",
        btnContinue: "Fortsett",
        btnDownloadUpdate: "Last ned oppdatering",
        btnInstallUpdate: "Installer oppdatering",
        btnOk: "Ok",
        btnRetry: "PrÃ¸v igjen",
        btnSkip: "Hopp over",
        checkingForUpdates: "Sjekker etter oppdatering",
        downloadingFailed: "Nedlasting mislyktes",
        downloadingPackage: "Laster ned oppdatert pakke, vent littÂ ...",
        finishingUpdate: "Oppdatering er ferdig",
        installingUpdate: "Installere oppdatering",
        internalError: "Intern feil",
        rebootRequired: "Omstart kreves",
        startingComponents: "Starter programvarekomponenter",
        stoppingComponents: "Avslutter softwarekomponenter",
        synchronizingDatabases: "Synkronisering av databaser",
        updateAvailable: "Oppdatering tilgjengelig, velg komponenter som skal oppdateres",
        updateDownloaded: "Oppdateringen er nedlastet",
        updateFailed: "Oppdateringsprosessen er mislykket",
        updateInstalled: "Oppdateringen er installert",
        verificationFailed: "Bekreftelse av oppdateringspakken mislyktes",
        verifyingPackage: "Bekrefter nedlastet pakke",
        yourSoftwareIsUpToDate: "Programvaren er oppdatert",
        yourSoftwareVersion: "Din programvareversjon: %{0}"
    },
    importData: {
        abortImportingData: "Avbryt import",
        aborted: "Import ble avbrutt",
        backupLocalDB: "Backup local database",
        confirmRestore: "Er du sikker pÃ¥ at du vil gjenopprette alle lokale innstillinger?",
        dataMissing: "Import mislyktes fordi kildefilen ikke inneholdt noe data.",
        deleteImportedData: "Slett importdata",
        encodingFile: "Filkoding",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Import mislyktes fordi kildefilen ser ut til Ã¥ vÃ¦re skadet.",
        fileMissing: "Import mislyktes fordi kildefilen ikke eksisterer.",
        format: "Format",
        formatPath: "Formatbane",
        headerMissing: "Import mislyktes fordi filoverskriften mangler.",
        import: "Importer",
        importAborted: "Import avbrutt",
        importAborting: "Import avbrytes",
        importFailed: "Import mislyktes pga. uforutsett feil",
        importLocalSettings: "Import Local Settings",
        importPrices: "Importer priser",
        imported: "Importering lyktes",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Importerer",
        noFormatAvailable: "Intet format tilgjengelig",
        processing: "Behandler",
        processingCustomFormulas: "Behandler spesialfargeblanding",
        processingCustomers: "Behandler kunder",
        productsFile: "Produktfil",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Import er i gang",
        unknownFormat: "Import mislyktes da kildefilen er av ukjent format",
        userFormulasFile: "Bruk oppskriftsfiler"
    },
    infoType: {
        baseDensity: "Basetetthet",
        baseMass: "Basemasse",
        baseUfiCode: "Base UFI -kode",
        baseVolume: "Basevolum",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS-grad",
        colorLab: "Fargelabdata",
        colorRgb: "Farge RGB",
        colorRgbHex: "Farge RGB Hex",
        colorXyz: "Farge xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Tonepastamasse",
        colorantUfiCodes: "UFI -koder med fargestoffer",
        colorantVolume: "Tonepastavolum",
        formulaDate: "Formel dato",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formel mer info",
        formulaMoreInfoInternal: "Formel mer info intern",
        formulaMoreInfoPrint: "Formel mer info skrive ut",
        hbw: "HBW",
        isPackageGravimetric: "Er pakken gravimetrisk",
        maxColorantMass: "Maksimalt tillatt tonepastamasse",
        maxColorantVolume: "Maksimalt tillatt tonepastavolum",
        nominalMass: "Pakkens nominelle masse",
        nominalVolume: "Pakkens nominelle volum",
        overfillDetected: "Overfylling oppdaget",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Total malingsmasse",
        totalPaintVolume: "Total malingsvolum",
        ufiCodesTable: "UFI -koder tabell",
        verifiedFormula: "Verifisert formel",
        yValue: "Y-verdi"
    },
    initialTab: {
        favoriteFormulas: "Favorittoppskrifter",
        lastDispensedFormulas: "Sist fargeblandingsoppskrift",
        searchNewFormula: "SÃ¸k etter oppskrift"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "handling",
        add: "legg til",
        addition: "tillegg",
        additional: "ytterligere",
        address: "adresse",
        admin: "admin",
        advanced: "Avansert",
        after: "etter",
        afterDispensing: "efter dosering",
        alfa: "Alfa",
        all: "alle",
        allow: "tillat",
        alphabetically: "alfabetisk",
        amount: "mengde",
        api: "api",
        ask: "spÃ¸r",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "tilgjengelig pris",
        backup: "sikkerhetskopi",
        banner: "banner",
        barcode: "strekkode",
        barcodes: "strekkoder",
        base: "base",
        before: "fÃ¸r",
        begin: "starte",
        bfs: "BFS",
        bottom: "bunn",
        brand: "merke",
        brush: "bÃ¸rste",
        bug: "feil",
        button: "knapp",
        buy: "kjÃ¸pe",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibrering",
        can: "spann",
        canHandling: "spann hÃ¥ndtering",
        canister: "beholder",
        canisterFilling: "beholder pÃ¥fylling",
        canisterLevels: "beholder nivÃ¥er",
        canisters: "beholdere",
        cap: "lokk",
        center: "Senter",
        centre: "Sentrum",
        change: "endring",
        changelog: "Endringslogg",
        channels: "kanaler",
        check: "kontroller",
        chunk: "del",
        chunks: "deler",
        city: "by",
        clean: "ren",
        cleaning: "rengjÃ¸ring",
        clientIdentifier: "klient-id",
        close: "tett",
        closest: "tettest",
        code: "kode",
        collect: "samle inn",
        color: "farge",
        colorLink3: "ColorLink3",
        colorPanel: "Fargepalett",
        colorReader: "ColorReader",
        colorant: "tonepasta",
        colorantConsumption: "tonepasta forbruk",
        colorantPrice: "tonepastapris",
        colorants: "tonepastaer",
        colorix: "Colorix",
        colour: "farge",
        communication: "kommunikasjon",
        compare: "sammenligne",
        competitive: "konkurransedyktige",
        computer: "datamaskin",
        config: "konfigurer",
        configuration: "konfigurasjon",
        confirm: "bekreft",
        confirmation: "bekreftelse",
        connection: "forbindelse",
        contactPerson: "kontaktperson",
        control: "Kontroll",
        copies: "kopier",
        corob: "Corob",
        cost: "kostnader",
        country: "land",
        create: "opprett",
        currency: "valuta",
        current: "nÃ¥vÃ¦rende",
        custom: "Spesiallagd",
        customers: "kunder",
        daily: "daglig",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "dato",
        decimals: "desimaler",
        default: "standard",
        delay: "forsinkelse",
        delete: "slett",
        deletion: "sletting",
        deltaE: "delta e",
        device: "enhet",
        devices: "enheter",
        diagnosticTile: "diagnostiseringsfelt",
        dialog: "dialog",
        direct: "direkte",
        disconnect: "avbryt",
        discount: "rabatt",
        dispense: "doser",
        dispenser: "fargeblandemaskin",
        dispensing: "dosering",
        down: "ned",
        download: "last ned",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "redigere",
        editor: "editor",
        email: "E-post",
        error: "feil",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "Excel",
        expiration: "utlÃ¸p",
        export: "eksport",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fargekart",
        fastFluid: "Fast & Fluid",
        file: "fil",
        fill: "fyll",
        fillToMax: "fyll til maks.",
        find: "ï¬nn",
        first: "fÃ¸rste",
        flex: "Flex",
        folder: "mappe",
        formula: "resept",
        formulas: "resepter",
        from: "fra",
        fts5: "FTS5",
        fullScreen: "fullskjerm",
        fullText: "fulltekst",
        fulltext: "fulltekst",
        g: "g",
        genericPricing: "generisk prissetting",
        hLD: "HLD",
        hard: "hardt",
        hbw: "hbw",
        help: "hjelp",
        helpCenter: "hjelpesenter",
        hero: "Hero",
        history: "historikk",
        home: "hjem",
        host: "vert",
        humidifier: "luftfukter",
        iDD: "IDD",
        identification: "identifikasjon",
        image: "bilde",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "importere",
        individually: "Individuelt",
        info: "info",
        information: "informasjon",
        initial: "initial",
        initialization: "initialisering",
        initialize: "Initialisere",
        insert: "sette inn",
        install: "installere",
        intellyPurge: "intelly rensing",
        invalid: "ugyldig",
        ipAddress: "IP-adresse",
        italtinto: "Italtinto",
        items: "gjenstander",
        keyboard: "tastatur",
        kg: "kg",
        kiosk: "fullskjerm",
        kioskMode: "fullskjermmodus",
        l: "L",
        lLD: "LLD",
        lab: "Lab",
        label: "etikett",
        labels: "etikett",
        language: "sprÃ¥k",
        largo: "Largo",
        last: "siste",
        lenteq: "Lenteq",
        levels: "nivÃ¥er",
        license: "lisens",
        light: "lys",
        limit: "grense",
        link: "lenke",
        linux: "Linux",
        load: "lese inn",
        lock: "lÃ¥s",
        logFiles: "loggfiler",
        logic: "logikk",
        logo: "logo",
        lower: "lavere",
        machine: "maskiner",
        machineConfiguration: "maskinkonfigurasjon",
        machineManagement: "maskinstyring",
        machineName: "maskinnavn",
        main: "primÃ¦re",
        maintenance: "vedlikehold",
        manual: "manuell",
        manualAddition: "manuelt tillegg",
        manualDispensing: "manuell dosering",
        manualScan: "manuell skanning",
        margins: "marginer",
        markups: "pÃ¥slagstall",
        mass: "masse",
        match: "match",
        measure: "mÃ¥le",
        measurement: "mÃ¥ling",
        measurementUnits: "mÃ¥lenheter",
        melody: "melodi",
        message: "melding",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutter",
        misura: "Misura",
        ml: "ml",
        mode: "tilstand",
        model: "modell",
        modification: "endring",
        modify: "endre",
        monthly: "mÃ¥nedlige",
        moreInfo: "mer informasjon",
        movableTable: "bevegelig bord",
        move: "flytte",
        music: "musikk",
        myOrders: "mine ordrer",
        name: "navn",
        naming: "navngiving",
        nano: "Nano",
        navigation: "nvigasjon",
        new: "nye",
        nextDriver: "NextDriver",
        night: "natt",
        nixPro: "Nix Pro",
        notes: "merknader",
        notification: "varsling",
        number: "nummer",
        off: "off",
        open: "Ã¥pne",
        order: "bestill",
        ordering: "bestilling",
        overfill: "overfylling",
        overview: "oversikt",
        overwrite: "overskrive",
        own: "egen",
        pCPDriver: "PCPDriver",
        package: "pakke",
        packagePrice: "pakkepris",
        packages: "pakker",
        panels: "Paneler",
        parameter: "Parameter",
        path: "Bane",
        pc: "Pc",
        phone: "telefon",
        phoneNumber: "telefonnummer",
        picture: "bilde",
        place: "plasser",
        placement: "plassering",
        plug: "plugg",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "pluss",
        pointOfSale: "salgsstedet",
        popUp: "popup",
        pos: "POS",
        present: "nÃ¥vÃ¦rende",
        preview: "forhÃ¥ndsvisning",
        price: "pris",
        priceExport: "priseksport",
        priceGroup: "prisgruppe",
        priceImport: "prisimport",
        prices: "priser",
        pricing: "prissetting",
        primaryCurrency: "primÃ¦r valuta",
        print: "skriv ut",
        printer: "skriver",
        printing: "skriver ut",
        problem: "problem",
        product: "produkt",
        productPrice: "produktpris",
        profiledValues: "profilbestemte verdier",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "rense",
        purgeType: "rensingstype",
        purgeVolume: "rensingsvolumer",
        quality: "kvalitet",
        quick: "hurtig",
        quickTint: "hurtigtoning",
        rM: "RM",
        raise: "lÃ¸ft",
        rcc: "RCC",
        reader: "Reader (Colorix Reader Pro)",
        reboot: "omstart",
        receive: "motta",
        recirculate: "resirkulere",
        recirculation: "resirkulering",
        redlike: "Redlike",
        refill: "etterfyll",
        registration: "registrering",
        regular: "regelmessig",
        removal: "fjerning",
        remove: "fjern",
        report: "rapport",
        reset: "nullstill",
        resolution: "opplÃ¸sning",
        restart: "omstart",
        rgb: "RGB",
        rights: "rettigheter",
        rounding: "avrunding",
        rules: "regler",
        sanTint: "SanTint",
        save: "lagre",
        scale: "skala",
        scan: "skann",
        scope: "omfanget",
        screen: "skjerm",
        screensaver: "skjermsparer",
        search: "sÃ¸k",
        secondaryCurrency: "sekundÃ¦r valuta",
        select: "velg",
        selectedFormula: "Selected formula",
        sell: "selge",
        sensor: "sensor",
        serialNumber: "serienummer",
        server: "server",
        servers: "servere",
        service: "tjeneste",
        serviceAction: "tjenestehandling",
        serviceActions: "tjenestehandlinger",
        serviceSoftware: "tjenesteprogramvare",
        serviceWindow: "tjenestevindu",
        settings: "innstillinger",
        shelf: "hylle",
        shortcuts: "snarveier",
        shot: "shot",
        show: "vis",
        shutDown: "avslutt",
        shutdown: "avslutning",
        silent: "stille",
        simple: "simpel",
        simulation: "simulering",
        size: "stÃ¸rrelse",
        skip: "hopp over",
        smartPurge: "smart rensing",
        software: "programvare",
        softwareSupplier: "programvareleverandÃ¸r",
        sort: "sortere",
        sound: "lyd",
        spectro: "spektro",
        spectrophotometer: "spektrofotometer",
        speed: "hastighet",
        split: "deler",
        start: "start",
        startup: "oppstart",
        statistics: "statistikk",
        status: "status",
        stir: "rÃ¸r",
        stirring: "omrÃ¸ring",
        street: "gate",
        support: "stÃ¸tte",
        surcharge: "tillegg",
        tab: "fane",
        tabs: "faner",
        task: "oppgave",
        template: "mal",
        testing: "test",
        time: "tidspunkt",
        tintingManagementCenter: "administrasjonssenter for toning",
        to: "til",
        toDispense: "Ã¥ dosere",
        tolerance: "toleranse",
        top: "topp",
        total: "samlede",
        translation: "oversettelse",
        turnOff: "slÃ¥ av",
        turntable: "Dreieskive",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "Amerikansk gallon",
        uSQuart: "Amerikansk quart",
        unit: "enhet",
        up: "opp",
        update: "oppdatering",
        url: "Url",
        user: "bruker",
        userGroups: "brukergrupper",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "mva.",
        validate: "validere",
        validation: "validering",
        version: "versjon",
        virtual: "virtuelle",
        volume: "volum",
        weekly: "ukentlige",
        window: "vindu",
        windows: "vinduer",
        with: "med",
        without: "uten",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y-verdi",
        zipCode: "postnummer",
        zoom: "zoom"
    },
    languages: {
        bg: "Bulgarsk",
        cs: "Tsjekkisk",
        da: "Danmark",
        de: "Tysk",
        el: "Gresk",
        en: "Engelsk",
        es: "Spansk",
        fr: "Fransk",
        hr: "Kroatisk",
        hu: "Ungarsk",
        id: "Indonesisk",
        is: "Island",
        it: "Italiensk",
        lt: "Litauisk",
        lv: "Latvisk",
        ms: "Malayisk",
        nl: "Nederlandsk",
        no: "Norge",
        pl: "Polsk",
        pt: "Portugisisk",
        ro: "Rumensk",
        ru: "Russisk",
        sk: "Slovakisk",
        sr: "Serbisk",
        sv: "Sverige",
        zh: "Kinesisk"
    },
    license: {
        activateLicense: "Aktiver lisens",
        activateNewLicense: "Aktiver ny lisens",
        checkLicenseKey: "Sjekk lisensnÃ¸kkel",
        companyId: "Firma-ID",
        contactPerson: "Kontaktperson",
        copy: "Kopier",
        country: "Land",
        emptyCity: "By er obligatorisk informasjon",
        emptyCountry: "Land er obligatorisk informasjon",
        emptyName: "Butikknavn er obligatorisk informasjon",
        enterIdentificationKeys: "Tast inn identifikasjonsnÃ¸kkelen",
        expirationDate: "UtlÃ¸psdato  %{dateTime}",
        fillRegistration: "Fyll ut registreringsdata (bla nedover for Ã¥ se mer)",
        insertLicense: "Sett inn generert nÃ¸kkel til offline aktivering",
        invalidEmail: "Den inntastede e-posten er ugyldig",
        invalidPhone: "Det inntastede telefonnummeret er ugyldig",
        itemsMarkedasterisk: "(felter markert med en stjerne mÃ¥ utfylles)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Leid lisens",
        licenseActivated: "Lisensen er allerede aktivert",
        licenseStatus: "Lisensstatus",
        licenseWillExpire: "Lisensen utlÃ¸per om %{dayCount} dager",
        licenseWillExpireOneDay: "Lisensen utlÃ¸per om %{dayCount} dager",
        machineInformation: "Maskininformasjon",
        noLicenseAvailable: "Ingen lisens tilgjengelig",
        noProductsForKey: "Det finnes ingen produkter tilgjengelig for den Ã¥pne identifikasjonsnÃ¸kkelen.",
        pointOfSale: "Salgssted",
        producer: "Produsent",
        reactivate: "Aktiver pÃ¥ nytt",
        reactivateLicense: "Reactivate license",
        region: "Region",
        registerLicense: "Lag en kopi av aktiveringsforespÃ¸rselen og naviger til:",
        registrationForm: "Registrering",
        selectProduct: "Velg produkt",
        serialNumber: "Serienummer",
        skipNewLicense: "Hvis du vil aktivere ny lisens senere, kan du hoppe over dette",
        unlimitedLicense: "Ubegrenset lisens",
        userId: "Bruker-ID",
        uuid: "Lisens UUID",
        versionDetails: "Versjonsdetaljer",
        versionScope: "VersjonsformÃ¥l",
        versionType: "Versjonstype",
        zip: "Postnummer"
    },
    login: {
        authenticate: "Autentiser",
        logIn: "PÃ¥logging",
        loginAs: "Logg pÃ¥ som en annen bruker",
        messages: {
            incorrectUsername: "Brukernavn og adgangskode er feil "
        },
        password: "Adgangskode",
        username: "Brukernavn"
    },
    machineActionHistory: {
        actionHistory: "Handlingshistorikk"
    },
    machineErrors: {
        channel: "Kanaler",
        code: "Kode",
        machineErrors: "Maskinfeil",
        noMachineErrors: "Det er for Ã¸yeblikket ingen maskinfeil",
        resetErrors: "Nullstillingsfeil"
    },
    machineSettings: {
        action: "Handling",
        addAutotask: "Legg til Autotask",
        autoCanisterIn: "Automatisk kanister inn",
        autoCanisterOut: "Automatisk kanister ut",
        automaticRefill: "Automatisk pÃ¥fylling",
        autotaskSettings: "Autotask-innstillinger",
        backupConfiguration: "Sikkerhetskopi av fargeblandingsmaskinens konfigurasjon",
        brushMaintenance: "Vedlikehold av bÃ¸rster",
        capMaintenance: "Vedlikehold av lokk",
        checkCanisterBeforeDispense: "Sjekk kanistere fÃ¸r fargeblanding",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Kontroller den minimale tonbare mengden fargestoffer",
        checkOverfill: "Sjekk kan overfylles",
        checkTotalCntAmounts: "Kontroller total mengde brekkfarger for base",
        cleanAll: "RengjÃ¸r alle",
        computerReboot: "Omstart av datamaskin",
        computerShutdown: "Nedstenging av datamaskin",
        connectMachine: "Koble til maskin",
        days: "Dager",
        daysOfMonth: "Dager om mÃ¥neden",
        devices: "Apparat",
        disabled: "Deaktivert",
        dispenseAndPurge: "Fargeblanding og rengjÃ¸ring",
        dispenseOnly: "Kun fargeblanding",
        dispenserCleaning: "RengjÃ¸ring av fargeblandingsmaskin",
        dispensingWithErrorsEnabled: "Tillat dosering til tross for valideringsfeil",
        editAutotask: "Rediger Autotask",
        firstRun: "FÃ¸rste forsÃ¸k",
        hours: "Timer",
        humidifier: "Luftfukter",
        humidifierWaterLevelMaintenance: "Vedlikehold av luftfukterens vannivÃ¥",
        machineConfigurationNoCanisters: "Maskinkonfigurasjonen inneholder ingen beholdere.",
        machineName: "Maskinnavn",
        machineSettings: "Maskininnstillinger",
        manualPuncher: "Manuell stansing",
        minDispensedAmount: "Minimal fargeblandingsmengde",
        minutes: "Minutter",
        nextRun: "Neste runde",
        noAutotasksSet: "Ingen autotasker angitt",
        noDataAvailable: "Ingen data tilgjengelig",
        noMachine: "Ingen maskin er tilkoblet",
        onStart: "PÃ¥ start",
        plugger: "Tilkoblingsknapp",
        postpone: "Utsetting av boks/spann",
        puncher: "Stoppknapp",
        purgeAll: "Rens alle",
        purgeOnly: "Rens kun",
        recirculateAll: "Resirkuler alle",
        recirculateChannels: "Resirkuler kanaler",
        recirculationSpeed: "Resirkulasjonshastighet",
        recirculationTime: "Resirkulasjonstid",
        refillAll: "Fyll pÃ¥ alle",
        refillCanisters: "Fyll pÃ¥ alle kanisterne",
        runAt: "Daglig kl.",
        runDefinedDaysAt: "Definerte dager kl.",
        runEvery: "KjÃ¸r hver",
        runInDays: "KjÃ¸r i dager",
        serialNum: "Serienummer",
        settingsMachine: "Innstillingsmaskin",
        smartPurgeAll: "Smart rensing av alle",
        smartPurgeChannels: "Smart rensing av kanaler",
        smartPurgeRules: "Regler for smart rensing",
        startType: "Starttype",
        stirAll: "RÃ¸r alle",
        stirCanisters: "RÃ¸r kanisterne",
        stirringSpeed: "RÃ¸rehastighet",
        stirringTime: "RÃ¸retid",
        switchPlateMaintenance: "Vedlikehold av kontaktplaten",
        theCurrentlySelectedMachine: "Gjeldende valgt maskin",
        threshold: "Begynnelse",
        turntable: "Dreieskive",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Mengde",
        weekdays: "Hverdag"
    },
    mainTab: {
        acceptedFormula: "Godkjent formel",
        addBuildingSite: "Add building site",
        addToFavorites: "Legg til i favoritter",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "En eller flere tonepastaer er tilgjengelig",
        dispensedPackages: "Fargeblandet pakke",
        dispensingInProgress: "Fargeblanding er i gang",
        dispensingIsAborted: "Fargeblanding er avbrutt",
        dispensingIsNotAvailable: "Fargeblanding er ikke tilgjengelig",
        dispensingProgress: "%{done} av %{all}",
        editColorant: "Rediger tonepasta",
        editNote: "Rediger notat",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Fremtving fargeblanding",
        formulaInvalidColorants: "Oppskriften inneholder ugyldige tonepastaer: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Skjulte vifter",
        hiddenProducts: "Skjulte produkter",
        historicalFormulas: "Historiske oppskrifter",
        lowerDeltaNumber: "Lavere deltanummer mer nÃ¸yaktig samsvar",
        machineError: "Maskinfeil",
        machineIsBusy: "Maskinen er opptatt",
        machineNotConnected: "Maskinen er ikke tilkoblet",
        manualColorantAddition: "Manuelt tillegg av tonepasta",
        modifiedFormula: "Oppskriften er endret",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "Ny farge etter skalering",
        newRgbNotAccuratelyMeasured: "Ny RGB mÃ¥les ikke nÃ¸yaktig, den er bare veiledende",
        noBaseAvailable: "Ingen base er tilgjengelig",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Ingen tonepastaer",
        noCustomer: "Ingen kunder",
        noCustomers: "Ingen kunder tilgjengelig",
        noDispenseNotesAvailable: "Ingen notater for fargeblanding er tilgjengelig",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Ingen oppskrift er valgt",
        noInternalNotesAvailable: "Ingen interne notater er tilgjengelige",
        noNotesAvailable: "Ingen notater er tilgjengelige",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Ingen pakker er valgt",
        noProductAvailable: "No product is available",
        noResultsFound: "Ingen resultater funnet.",
        openLocalFile: "Ãpne fra lokal database",
        openOnlineFile: "Ãpent fra Internett",
        order: "Ordre",
        orderingIsNotAvailable: "Ordre er ikke tilgjengelig",
        originalColor: "Originalfarge",
        overAvailableLevel: "Over det tilgjengelige nivÃ¥et",
        package: "Pakke",
        packageIsRequired: "Pakke er pÃ¥krevd",
        packaging: "Emballasje",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Utskrift er ikke tilgjengelig",
        productFiles: "Produktfiler",
        productFilesViewer: "Visning av produktfiler",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Vanlig pris",
        resetFormulaData: "Ny oppskrift",
        rgbOnlyIndicative: "RGB kun veiledende!",
        saveAsCustom: "Lagre som",
        saveToStatsIsNotAvailable: "Det er ikke mulig Ã¥ lagre i historikk",
        searchForCheaper: "SÃ¸k etter billigere",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Spesialpris",
        specialPriceVip: "Spesialpris VIP",
        splitFormula: "Del opp oppskrift",
        withVAT: "med moms",
        withoutVAT: "uten moms"
    },
    marginSettings: {
        allBases: "Alle baser",
        allProducts: "Alle produkter",
        editMargin: "Rediger profitt (margin)",
        marginAndDiscountWarning: "Du mÃ¥ angi alternativ for prisberegning for bruk av marginer og rabatter.",
        marginSettings: "Profitt (margin)-innstillinger",
        marginsFor: "Profitt (margin) for",
        markupColorants: "Ãnsket profittprosent (markup) tonepasta",
        sizeOfPackage: "PakkestÃ¸rrelse",
        valueBase: "Baseverdi",
        valueColorant: "Tonepastaverdi"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Endre tonepastaenhet",
        payAttention: "VÃ¦r oppmerksom!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Fargekartfilter",
            formulasOverLimit: "Cirka %{count} resultater. PrÃ¸v Ã¥ skrive flere tegn.",
            foundFormulas: "%{count} oppskrifter funnet",
            help: "Hjelp:",
            helpText:
                "Skriv f.eks. '%{filter}' for Ã¥ sÃ¸ke etter oppskrifter som starter med '%{formula}', produkter som starter med '%{product}' og fargekart '%{fandeck}'.",
            productFilter: "Produktfilter",
            searchInFormulas: "SÃ¸k i oppskrifter",
            typeMore: "Skriv flere tegn."
        },
        menu: {
            actionHistory: "Handlingshistorikk",
            additionalFormulaTab: "Ekstra oppskriftsfane",
            advancedSettings: "Avanserte innstillinger",
            autotaskSettings: "Autotask",
            availableDatabases: "Tilgjengelige databaser",
            availablePrices: "Tilgjengelige priser",
            bugReport: "Feilrapport",
            canisterBarcodes: "Kanister-strekkoder",
            canisterDispensingLogic: "Fargeblandingslogikk",
            canisterFilling: "KanisterpÃ¥fylling",
            canisterSettings: "Kanisterinnstillinger",
            clientServerSettings: "Klient/server-tilkobling",
            closing: "Lukker",
            color: "Farge",
            colorModification: "Fargeendring",
            colorPanel: "Fargepanelinnstillinger",
            colorRepresentation: "Fargerepresentasjon og data",
            colorSearch: "FargesÃ¸k",
            colorant: "Tonepasta",
            colorantConsumption: "Tonepastaforbruk",
            colorantPricing: "Tonepastaprising",
            colorantRefillHistory: "Bekreft pÃ¥fyll av tonepasta",
            competitiveSearch: "Simulerende fargesÃ¸k",
            connections: "Tilkoblinger",
            currency: "Valutainnstillinger",
            customData: "Spesiallagde data",
            database: "Database",
            databaseCheck: "Databasesjekk",
            databaseConnection: "Databasetilkobling",
            defaultValues: "Standardverdier",
            devices: "Enheter",
            dispensingHistory: "Fargeblandingshistorikk",
            dispensingSettings: "Fargeblandingsinnstillinger",
            driverSettings: "Driverinnstillinger",
            environment: "Omgivelser",
            environmentConfiguration: "Omgivelsesinnstillinger",
            environmentalSettings: "Omgivelsesinnstillinger",
            favorites: "Favoritter",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatering",
            formula: "Formula",
            formulaData: "Data",
            formulaModification: "Formula modification",
            formulaPanels: "Oppskriftspanel",
            formulaSettings: "Oppskriftsinnstillinger",
            formulaUnit: "Oppskriftsenhet",
            generalSearch: "Generelt sÃ¸k",
            globalSettingsSearch: "SÃ¸k etter globale innstillinger",
            helpItems: "Innstillinger for hjelp",
            importAndExport: "Import og eksport",
            importAndExportData: "Importer spesiallagede data",
            importCustomData: "Importer spesiallagede data",
            initialFormulaTab: "Opprinnelig oppskriftsfane",
            interfaceSettings: "Grensesnittinnstillinger",
            keyboardShortcuts: "Tastatursnarvei",
            language: "SprÃ¥k",
            languageSettings: "SprÃ¥kinnstillinger",
            layout: "Oppsett",
            license: "Lisens",
            licenseData: "Lisensdata",
            licenseIdentification: "Lisensidentifikasjon",
            licenseStatus: "Lisensstatus",
            licenseSupplier: "LisensleverandÃ¸r",
            licenseVersion: "Lisensversjon",
            localData: "Lokale data",
            machine: "Maskininformasjon",
            machineActions: "Maskinhandlinger",
            machineAndDevices: "Maskin og apparater",
            machineManagement: "Maskinstyring",
            machineSettings: "Maskininnstillinger",
            mainSettings: "Hovedinnstillinger",
            maintenance: "Vedlikehold",
            marginAndDiscount: "Margin og rabatt",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Navigasjonselementer",
            newFormulaWindow: "Oppskrift",
            orderSearch: "OrdresÃ¸k",
            orderSettings: "Bestillingsinnstillinger",
            packageSurcharge: "Pakketillegg",
            popUps: "Popup",
            posInfo: "Salgsstedsinformasjon",
            price: "Prisinnstillinger",
            priceManagement: "Prisadministrasjon",
            priceSettings: "Prisinnstillinger",
            pricingOptions: "Prisinnstillinger",
            printSettings: "Utskrivingsinnstillinger",
            productPricing: "Produktprising",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Hurtig fargeblandingsinnstilling",
            rccConfig: "RCC-innstillinger",
            rccConnection: "Ingen RCC-tilkobling",
            rccSettings: "RCC-innstillinger",
            refillSettings: "Refill Settings",
            refillingLogic: "PÃ¥fyllingslogikk",
            registration: "Registrering",
            searchSettings: "SÃ¸keinnstillinger",
            serverPlugins: "Server-programtillegg",
            serviceActions: "Serverhandlinger",
            settings: "Innstillinger",
            simplifiers: "Forenklinger",
            singleActions: "Enkelte handlinger",
            smartPurgeRules: "Regler for smart rensing",
            softwareOptions: "Programvaremuligheter",
            spectroSettings: "Spektrometerinnstillinger",
            statistics: "Statistikk",
            switchToFrontdesk: "Bytt til resepsjon",
            switchToFullRedlike: "Bytt til %{name}",
            switchToLight: "Bytt til %{name}",
            switchToMachine: "Bytt til maskin",
            tabs: "Fane og popup",
            testBarcodes: "Testing av strekkode",
            updateOptions: "Oppdateringsmuligheter",
            userManagemenet: "Brukeradministrasjon",
            visibleUnits: "Synlige enheter"
        },
        navBar: {
            barcode: "Strekkode",
            help: "Hjelp",
            hideItems: "Skjul produkter / vifter"
        },
        notificationPanel: {
            noNotifications: "Ingen nye meldinger"
        },
        tabBar: {
            closeActive: "Lukk aktiv",
            closeAll: "Lukk alle",
            closeAllExceptActive: "Lukk alle unntatt aktive",
            customFormula: "Custom Formula",
            dispensingHistory: "Fargeblandingshistorikk",
            favorites: "Favoritter",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Tildel",
        assignment: "Arbeidsoppgave",
        createdDate: "Opprettelsesdato",
        finishDispensing: "Avslutt fargeblanding",
        foundInOrders: "Funnet i ordrer",
        inactiveDatabase: "Oppskriften er fra en inaktiv eller ukjent database %{0}",
        inactiveUnknownDatabase: "Oppskriften er fra en inaktiv eller ukjent database",
        newOrderReceived: "Du har mottatt en ny ordre!",
        noOrderSelected: "Ingen ordre valgt",
        release: "Frigi",
        status: {
            accepted: "akseptert",
            canceled: "annullert",
            created: "opprettet",
            done: "ferdig",
            partlyDone: "delvis ferdig",
            preparing: "forbereder",
            unknown: "ukjent"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adresse",
        contactName: "Kontaktnavn",
        contactPerson: "Kontaktperson",
        identification: "Identifikasjon",
        machineInformation: "Maskininformasjon",
        pos: "Salgssted",
        secondAddress: "Annen adresse",
        shopIdentification: "Butikkidentifikasjon",
        shopName: "Butikknavn",
        url: "URL-adresse",
        zipCode: "Postnummer"
    },
    priceTypeList: {
        priceBasePurchase: "Kostpris for base",
        priceBaseSell: "Salgspris for base",
        priceBaseSellFull: "Salgspris for base",
        priceCntPurchase: "Kostpris for tonepasta",
        priceCntPurchaseByColorantName: "Kostpris for %{0} tonepasta",
        priceCntPurchaseByName: "Kostpris for tonepasta ved navn",
        priceCntSell: "Salgspris for tonepasta",
        priceCntSellByColorantName: "Salgspris for %{0} tonepasta",
        priceCntSellByName: "Salgspris for tonepasta ved navn",
        priceCntSellFull: "Salgspris for tonepastaer",
        priceCntSellFullByColorantName: "Salgspris for tonepasta %{0}",
        priceCntSellFullByName: "Salgspris for tonepastaer per navn",
        priceGroupBarcode: "Prisgruppe strekkode",
        priceMarginAll: "Profitt (margin) for alle pakker",
        priceMarginPerPkg: "Profit (margin) for Ã©n pakke",
        priceSellPriceAll: "Salgspris for alle pakker",
        priceSellPricePerKg: "Salgspris pr. kilo",
        priceSellPricePerL: "Salgspris pr. liter",
        priceSellPricePerPkg: "Salgspris for Ã©n pakke",
        priceSurchargeAll: "Ekstragebyr for alle pakker",
        priceSurchargePerPkg: "Ekstragebyr for Ã©n pakke",
        priceTintPurchaseAll: "Fargeblandingskostpris for alle pakker",
        priceTintPurchasePerPkg: "Fargeblandingskostpris for Ã©n pakke",
        priceTintSellFullAll: "Salgspris for toning av alle pakker",
        priceTintSellFullAllPerPackage: "Salgspris for toning per pakke",
        priceTotalPurchaseAll: "Total kostpris for alle pakker",
        priceTotalPurchasePerKg: "Total kostpris pr. kilo",
        priceTotalPurchasePerL: "Total kostpris pr. liter",
        priceTotalPurchasePerPkg: "Total kostpris for Ã©n pakke",
        priceTotalSellFullAll: "Total salgspris for alle pakker",
        priceTotalSellFullPerKg: "Total salgspris per kg",
        priceTotalSellFullPerLiter: "Total salgspris per liter",
        priceTotalSellFullPerPackage: "Total salgspris per pakke"
    },
    pricing: {
        allBases: "Alle baser",
        allPackages: "Alle pakker",
        backup: "Backup",
        basesOfProduct: "Baser av %{productName}",
        colorantPricing: "Tonepastaprising",
        export: "Eksport",
        import: "Importer",
        packagePricing: "Pakkeprising",
        packageSurcharge: "Ekstragebyr pÃ¥ pakke",
        packages: "Pakker",
        packagesOfProduct: "Pakker av %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Prisgruppe for priser pr. liter",
        priceGroups: "Prisgrupper",
        pricePerLiter: "Pris pr. liter",
        productPricing: "Produktprising",
        purchasePrice: "InnkjÃ¸pspris",
        purchasePricePerLiter: "InnkjÃ¸pspris pr. liter",
        sellPrice: "Salgspris",
        surcharge: "Ekstragebyr"
    },
    print: {
        adminRightsRequired: "Administratorrettigheter kreves for Ã¥ redigere eller opprette en ny mal.",
        allowAutomaticPrint: "Automatisk utskrift",
        allowPrintAfterDispensing: "Tillat utskriving etter fargeblanding",
        allowPrintBeforeDispensing: "Tillat utskriving fÃ¸r fargeblanding",
        automaticPrint: "Skriv ut automatisk",
        choosePrinter: "Skriver",
        chooseSettings: "Rediger innstillinger",
        chooseTemplate: "Mal",
        copies: "Kopier",
        createTemplate: "Lag mal",
        createTemplateHint: "Lag en ny mal fra bunnen av. Lagre den i malmappen og start RCC pÃ¥ nytt.",
        defaultPrinter: "Standardskriver",
        defaultSettings: "Standard instillinger",
        defaultTemplate: "Standardmal",
        editTemplate: "Rediger mal",
        editTemplateHint: "Rediger %{name}. Endringer vil vÃ¦re synlige etter RCC -omstart.",
        noEditTemplate: "Ingen mal Ã¥ redigere",
        noPrinterSelected: "Ingen skriver er valgt",
        noPrintersAvailable: "Det er ingen skriver tilgjengelig",
        noTemplateSelected: "Ingen mal er valgt",
        noTemplatesAvailable: "Det er ingen mal tilgjengelig",
        numberOfCopies: "Antall kopier",
        openTemplateEditor: "Ãpen malredigerer",
        printAfterDispensing: "Skriv ut etter fargeblanding",
        printAsImage: "Skriv ut som bilde",
        printBeforeDispensing: "Skriv ut fÃ¸r fargeblanding",
        printOnRequest: "Skriv ut ved forespÃ¸rsel",
        printOptions: "Utskriftsmuligheter",
        printPagesAfterDispensing: "Antall etikettkopier",
        printPagesBeforeDispensing: "Antall etikettkopier",
        printPreview: "Skriv ut forhÃ¥ndsvisning",
        printSettings: "Utskrivingsinnstillinger",
        printTaskLinkVariable: "Lenke til en variabel",
        printVariable: "Skriv ut variabel",
        printerName: "Skrivernavn",
        printerOptions: "Skrivermuligheter",
        printerSettings: "Skriverinnstillinger",
        quickTintTemplate: "Mal for hurtig fargeblanding",
        setDefaultPrinter: "Still inn standardskriver",
        setDefaultTemplate: "Still inn standardmal",
        setQuickTintTemplate: "Angi mal for hurtig fargeblanding",
        showPreviewDialogBeforePrint: "Vis forhÃ¥ndsvisningsdialogbok fÃ¸r utskrift",
        template: "Mal",
        templateName: "Malnavn",
        templateSettings: "Malinnstillinger "
    },
    printTemplate: {
        baseCode: "Basekode",
        baseName: "Basenavn",
        bfs: "BFS / bredde-fÃ¸rst-sÃ¸k",
        colorantType: "Colorant type",
        customerCity: "Kundens poststed",
        customerEmail: "Kundens e-post",
        customerName: "Kundens navn",
        customerPhone: "Kundens telefonnummer",
        customerStreet: "Kundens gateadresse",
        customerZipCode: "Kundens postnummer",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS-grad",
        orderQrCode: "QR-kode",
        packageOrderCount: "Antall pakkeordrer",
        posAddress: "Salgsstedsadresse",
        posAddressSecond: "Salgsstedsadresse 2",
        posCity: "Salgssted",
        posContact: "Kontaktperson ved salgsstedet",
        posEmail: "Salgsstedets e-post",
        posPhone: "Salgsstedets telefonnummer",
        posUrl: "Salgsstedets URL-adresse",
        posZipCode: "Salgsstedets postnummer",
        priceBasePurchaseWithTax: "Kostpris for base inkl. moms",
        priceBaseSellWithTax: "Salgspris for base inkl. moms",
        priceCntPurchaseWithTax: "Kostpris for tonepasta inkl. moms",
        priceCntTotalSellWithTax: "Salgspris for tonepasta inkl. moms",
        priceMarginAllWithTax: "Profitt (margin) for alle pakker inkl. moms",
        priceMarginPerPkgWithTax: "Profitt (margin) for Ã©n pakke inkl. moms",
        priceSellPriceAllWithTax: "Salgspris for alle pakker inkl. moms",
        priceSellPricePerKgWithTax: "Salgspris pr. kilo inkl. moms",
        priceSellPricePerLWithTax: "Salgspris pr. liter inkl. moms",
        priceSellPricePerPkgWithTax: "Salgspris for Ã©n pakke inkl. moms",
        priceSurchargeAllWithTax: "Ekstragebyr for alle pakker inkl. moms",
        priceSurchargePerPkgWithTax: "Ekstragebyr for Ã©n pakke inkl. moms",
        priceTintPurchaseAllWithTax: "Kostpris for fargeblanding av alle pakker inklusiv moms",
        priceTintPurchasePerPkgWithTax: "Kostpris for fargeblanding av Ã©n pakke inklusiv moms",
        priceTotalPurchaseAllWithTax: "Kostpris for fargeblanding av alle pakker inkl. moms",
        priceTotalPurchasePerKgWithTax: "Total kostpris pr. kilo inkl. moms",
        priceTotalPurchasePerLWithTax: "Total kostpris pr. liter inkl. moms",
        priceTotalPurchasePerPkgWithTax: "Kostpris for fargeblanding av Ã©n pakke inkl. moms",
        productAltName: "Produkt",
        recipeInline: "Oppskrift"
    },
    products: {
        bases: "Base",
        numberOfProducts: "Antall produkter",
        packagesFor: "Pakker til",
        sizeOfPackage: "PakkestÃ¸rrelse"
    },
    purgeModal: {
        purgeAll: "Rens alle",
        purgeAllChannels: "Rens alle kanaler",
        purgeVolume: "Rens volum",
        startPurge: "Start rensing"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Fargeblanding pÃ¥gÃ¥r",
        dispensingIsNotAvailable: "Fargeblanding er ikke tilgjengelig",
        machineNotConnected: "Ingen maskin er tilkoblet",
        noColorantsSelected: "Ingen tonepastaer er valgt",
        noPrinterAvailable: "Utskrift kan ikke utfÃ¸res fordi det ikke er noen skriver tilgjengelig.",
        noTemplateAvailable: "Utskrift kan ikke utfÃ¸res fordi det ikke er noen mal tilgjengelig.",
        overMaxCanisterSize: "Ãn eller flere tonepastaer er ugyldige"
    },
    quickTintSettings: {
        alphabetically: "Alfabetisk",
        byCanister: "Etter kanister",
        closeAfterDispensing: "Lukk etter fargeblanding",
        closeBeforeDispensing: "Lukk fÃ¸r fargeblanding",
        quickTintSettings: "Innstillinger for hurtig fargeblanding",
        sorting: "Sortere",
        windowClosingRules: "Regler for vindulukking"
    },
    rccButtons: {
        abort: "avbryt",
        all: "alle",
        cancel: "annuller",
        continue: "fortsett",
        help: "hjelp",
        ignore: "ignorer",
        no: "ingen",
        noToAll: "ikke til alle",
        ok: "ok",
        postpone: "utsett",
        resume: "gjenoppta",
        retry: "prÃ¸v igjen",
        skip: "hopp over",
        yes: "ja",
        yesToAll: "ja til alle"
    },
    rccDialog: {
        98: "Kontroller base %{0} med strekkoden",
        99: "Sett inn base %{0} og bekreft (trykk pÃ¥ ok)",
        100: "Det er en feil pÃ¥ dispenseren, vil du nullstille feilen?",
        101: "Det er en feil pÃ¥ dispenseren, og den kan derfor ikke fortsette",
        102: "Nullstilling mislyktes, og den kan derfor ikke fortsette",
        103: "Oppskriften inneholder ugyldig tonepasta: %{0}",
        104: "Oppskriften inneholder ugyldige tonepastaer: %{0}",
        105: "Tonepasta: %{0} er under advarselsnivÃ¥",
        106: "Tonepastaene: %{0} er under advarselsnivÃ¥",
        107: "Tonepasta: %{0} er under kritisk nivÃ¥",
        108: "Tonepastaene: %{0} er under kritisk nivÃ¥",
        109: "Plasser boks/spann",
        110: "Plasser base: %{0} for oppskrift: %{1}",
        111: "Fjern boks/spann",
        112: "Stans boksen/spannet?",
        113: "Nullstiller feil, vent litt",
        114: "Flytter hylle, vent litt",
        115: "Stanser boksen/spannet, vent litt",
        116: "Oppskrift %{0}, vennligst vent | Pakke: %{1} av %{2} | Produkt: %{3} | Base: %{4} | StÃ¸rrelse boks/spann: %{5}",
        117: "Oppskrift %{0}, vennligst vent | Pakke: %{1} av %{2} | Produkt: %{3} | Base: %{4} | StÃ¸rrelse boks/spann: %{5}",
        118: "Toner, vent litt|Pakke: %{0} av %{1}",
        119: "Toner, vent litt|Pakke: %{0} av %{1}",
        120: "Annullerer fargeblanding, vent litt",
        121: "Valider strekkoden pÃ¥ boksen/spannet",
        122: "Valider basens strekkode | Produkt: %{0} | Base: %{1} | StÃ¸rrelse pÃ¥ boks/spann: %{2}",
        123: "Fargeblandingsprosessen er avbrutt. Ãnsker du Ã¥ gjenoppta fargeblandingen?",
        124: "Det oppsto en fargeblandingsfeil %{0} : %{1}. Ãnsker du Ã¥ gjenoppta fargeblandingen?",
        125: "SÃ¸rg for at den tidligere brukte boksen er plassert",
        126: "Pass pÃ¥ Ã¥ bruke en ny boks/spann siden fargeblandingsprosessen vil starte forfra",
        127: "Tonepasta: %{0} er under den minimale doseringsmengden. Vil du fortsette pÃ¥ tross av denne advarselen?",
        128: "Tonepastaer: %{0} er under den minimale doseringsmengden. Vil du fortsette pÃ¥ tross av denne advarselen?",
        129: "Den valgte oppskriften bryter overfyllingsreglen, den samlede mengden tonepastaer: %{0} %{1}, maksimalt tillatte mengder tonepastaer: %{2} %{3}. Vil du fortsette pÃ¥ tross av denne advarselen?",
        130: "Det er en feil pÃ¥ fargeblandingsmaskinen, skal feilen nullstilles?",
        131: "Det er en feil pÃ¥ fargeblandingsmaskinen, og den kan derfor ikke fortsette",
        132: "Nullstilling mislyktes og kan derfor ikke fortsette",
        133: "Renseoppskriften er tom og kan derfor ikke fortsette",
        134: "Renseoppskriften inneholder deler som ikke kan renses, Ã¸nsker du Ã¥ fortsette?",
        135: "Plasser spannet for rensing",
        136: "Fjern spann fra rensing",
        137: "Nullstiller feil, vent litt",
        138: "Flytter hylle, vent litt",
        139: "Renser, vent litt",
        140: "Renser, vent litt",
        141: "Annullerer rensing, vent litt",
        142: "Spann til rensing mangler, sÃ¸rg for at spannet er plassert korrekt",
        143: "Renseoppskriften inneholder deler som ikke kan renses, Ã¸nsker du Ã¥ fortsette?",
        144: "Plasser spannet for rensing",
        145: "Forbereder, vent litt",
        146: "Avslutter, vent litt",
        150: "RengjÃ¸r, vent litt",
        151: "RengjÃ¸r, vent litt",
        152: "Annullerer rengjÃ¸ring, vent litt",
        160: "Resirkulerer, vent litt",
        161: "Resirkulerer, vent litt",
        162: "Annullerer resirkulering, vent litt",
        170: "RÃ¸rer, vent litt",
        171: "RÃ¸rer, vent litt",
        172: "Annullerer rÃ¸ring, vent litt",
        180: "Initialiserer tilkoblingen til fargeblandingsmaskinen, vent litt",
        181: "Tilkobling til fargeblandingsmaskinen kan ikke etableres %{0}: %{1}",
        182: "Tilkobling til fargeblandingsmaskinen kan ikke etableres. Se loggfiler for mer informasjon",
        183: "Fargeblandingsmaskinen mangler tonepasta: %{0} som er angitt i databasen",
        184: "Fargeblandingsmaskinen mangler tonepastaer: %{0} som er angitt i databasen",
        185: "Lukker tilkoblingen til fargeblandingsmaskinen, vent litt",
        190: "Lukk servicevinduet for Ã¥ fortsette",
        200: "Nullstiller, vent litt",
        201: "Hard nullstilling, vent litt",
        202: "Initialisering, vent litt",
        203: "Nullstiller feil, vent litt",
        205: "Autocap Ã¥pner, vent litt",
        206: "Autocap lukkes, vent litt",
        207: "Flytter Autocap, vent litt",
        210: "Stanser, vent litt",
        211: "Tilkobler, vent litt",
        215: "Flytter hylle oppover, vent litt",
        216: "Flytter hylle nedover, vent litt",
        217: "Flytter hylle, vent litt",
        220: "Flytter bord til pÃ¥fyllingsposisjon: %{0}, vent litt",
        221: "Flytter bord til start, vent litt",
        222: "Flytter bord, vent litt",
        230: "Fargeblandingsmaskinen er opptatt, vent litt",
        240: "Fyll pÃ¥ kanister %{0}",
        241: "Fyll pÃ¥ kanister %{0}",
        242: "Plasser kanister: %{0} (%{1}) til pÃ¥fyllingsposisjon",
        243: "Fyll pÃ¥ kanister %{0} ved hjelp av strekkode",
        244: "Fyll pÃ¥ kanister %{0} ved hjelp av strekkode",
        250: "Fjern bÃ¸rstebeholderen, rengjÃ¸r den og fyll den med vann i henhold til instruksjonene",
        251: "Sett bÃ¸rstebeholderen tilbake pÃ¥ plass",
        254: "Ãpner autocap",
        255: "RengjÃ¸r autocap iht. instruksjonene",
        256: "Bekreft nÃ¥r rengjÃ¸ringen er avsluttet og autocap er pÃ¥ plass igjen",
        257: "Lukker autocap",
        260: "Fjern kontaktplaten og rengjÃ¸r den",
        261: "Sett kontaktplaten tilbake pÃ¥ plass",
        265: "RengjÃ¸r maskinen med en klut, og fjern alt sÃ¸l fra tonepasta eller annen vÃ¦ske",
        266: "Bekreft nÃ¥r det er utfÃ¸rt",
        270: "Fyll pÃ¥ luftfukterens vannbeholder, og bekreft nÃ¥r dette er gjort",
        271: "Fyll pÃ¥ luftfukterens vannbeholder, og bekreft nÃ¥r dette er gjort",
        272: "VannnivÃ¥et er fortsatt lavt, sjekk det pÃ¥ nytt",
        273: "VannnivÃ¥et er fortsatt lavt, sjekk det pÃ¥ nytt",
        274: "Sjekk vannivÃ¥et i luftfukterens vannbeholder, og fyll pÃ¥ om nÃ¸dvendig",
        275: "Vent litt",
        280: "Starter datamaskinen pÃ¥ nytt",
        281: "SlÃ¥r av datamaskinen",
        300: "Base mangler, sjekk om boksen/spannet er korrekt plassert",
        301: "Forbereder, vent litt",
        302: "Avslutter, vent litt",
        303: "Oppskriften kan ikke fargeblandes, fordi den inneholder tonepasta: %{0}, som er over den maksimale doseringsmengden som er definert for kanisteren",
        304: "Oppskriften kan ikke tones, fordi den inneholder tonepastaer: %{0}, som er over de maksimale doseringsmengdene som er angitt for kanisterene",
        305: "Tonepasta: %{0} kan ikke doseres pÃ¥ Ã©n gang. Vil du dele opp oppskriften?",
        306: "Tonepastaene: %{0} kan ikke doseres pÃ¥ Ã©n gang. Vil du dele opp oppskriften?",
        307: "Tonepasta: %{0} blir ikke dosert av fargeblandingsmaskinen, vil du fortsette og legge det til manuelt?",
        308: "Tonepastaene: %{0} blir ikke dosert av fargeblandingsmaskinen, vil du fortsette og legge dem til manuelt?",
        309: "Den valgte oppskriften er tom, bruk basen som den er",
        310: "Tonepasta kan ikke doseres, klargjÃ¸r base til manuell tilsetning av tonepasta",
        311: "Fjern basen og klargjÃ¸r den til manuell dosering av tonepasta",
        312: "Doser manuelt %{0} %{1} av tonepasta: %{2}, bekreft nÃ¥r det er utfÃ¸rt",
        313: "Doser oppskriften manuelt",
        314: "Den valgte oppskriften bryter overfyllingsreglen, total mengde tonepasta: %{0} %{1}, maksimalt tillatt mengde tonepasta: %{2} %{3}. Vil du fortsette pÃ¥ tross av denne advarselen?",
        315: "Skann eller skriv inn UFI -koden til basen",
        316: "Skann eller skriv inn UFI -koden til basen | Produkt: %{0} | Base: %{1} | spannstÃ¸rrelse: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatisk rensing vil starte",
        401: "Automatisk rensing vil starte",
        405: "BÃ¸rstebeholder mÃ¥ vedlikeholdes",
        406: "BÃ¸rstebeholder mÃ¥ vedlikeholdes",
        410: "Automatisk vedlikehold av lokk startes",
        411: "Automatisk vedlikehold av lokk startes",
        415: "Kontaktplaten skal rengjÃ¸res",
        416: "Kontaktplaten skal rengjÃ¸res",
        420: "Fargeblandingsmaskinen skal rengjÃ¸res",
        421: "Fargeblandingsmaskinen skal rengjÃ¸res",
        425: "PÃ¥fylling av kanister vil bli igangsatt",
        426: "PÃ¥fylling av kanister vil bli igangsatt",
        430: "Omstart av datamaskin er planlagt",
        431: "Omstart av datamaskin er planlagt",
        435: "Nedstenging av datamaskinen er planlagt",
        436: "Nedstenging av datamaskinen er planlagt",
        440: "Rensing av fargeblandingsmaskin er planlagt",
        441: "Rensing av fargeblandingsmaskin er planlagt",
        445: "Dispenserresirkulering er planlagt",
        446: "Dispenserresirkulering er planlagt",
        450: "DispenserrÃ¸ring er planlagt",
        451: "DispenserrÃ¸ring er planlagt",
        990: "Det oppstod en feil pÃ¥ fargeblandingsmaskinen %{0}: %{1}. Vil du prÃ¸ve igjen?",
        991: "Intern feil oppsto: %{0}",
        200000001: "Plasser boks/spann",
        200000002: "Fjern boks/spann",
        200000003: "Mengde for '%{0}' under minimum fargeblandingsmengde, vil du fortsette pÃ¥ egen risiko?",
        200000004: "Fyll pÃ¥ '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Databasebane",
        dispenser: "Fargeblandingsmaskin",
        dispenserConfigurationFile: "Konfigurasjonsfil for fargeblandingsmaskin",
        driverPath: "Driverbane",
        extensionPath: "Utvidelsesbane",
        folder: "Mappe",
        formulaPath: "Oppskriftsbane",
        host: "Vertsmaskin",
        iddPath: "IDD-konfigurasjonsfil",
        italtintoPath: "Italtinto konfigurasjonsbane",
        lldPath: "HLD rotkatalog",
        machineType: "Maskintype",
        noMachineAvailable: "Ingen maskin er tilgjengelig",
        protocolVersion: "Protokollversjon",
        rccDriverSettings: "Driverinnstillinger",
        resultPath: "Resultatbane",
        save: "Lagre innstillinger",
        saveSettingsWarning: "Advarsel! Endringer i denne delen kan fÃ¸re til funksjonsfeil i fargeblandingsmaskinen.",
        serviceSwPath: "Bane til serviceprogramvare",
        simulationPath: "Simuleringsbane"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Tillat manuell tonepastadosering",
        ask: "SpÃ¸r",
        canHandlingOptions: "HÃ¥ndteringsinnstillinger for boks/spann",
        checkCanBeforeDispense: "Sjekk boks/spann fÃ¸r fargeblanding",
        checkOverfill: "Sjekk overfylling",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Kun validering av tonepastapakke",
        disable: "Deaktiver",
        dispenseInvalidColorants: "Doser ugyldige tonepastaer",
        dispensingOptions: "Fargeblandingsinnstillinger",
        enable: "Aktiver",
        enableUserIdentification: "Brukeridentifikasjon",
        fullValidation: "Full validering",
        machineAccuracyWarning: "Advarsel om maskinens nÃ¸yaktighet",
        machineOptions: "Maskininnstillinger",
        machineUnit: "Maskinenhet",
        minimalDispenseAmount: "Minimal doseringsmengde",
        placeCanSensor: "Sensor for plassering av boks/spand",
        placeCanSensorDelay: "Forsinkelse pÃ¥ sensor for plassering av boks/spann",
        rccMachineSettings: "Maskininnstillinger",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "Sensor for flytting av boks/spand",
        removeCanSensorDelay: "Forsinkelse pÃ¥ sensor for flytting av boks/spann",
        save: "Lagre innstillinger",
        sec: "sekunder",
        skipPlaceCanDialog: "Hopp over dialog om plassering av boks/spann",
        skipRemoveCanDialog: "Hopp over dialog om flytting av boks/spann",
        splitFormula: "Del oppskriften",
        tmcEnabled: "Aktiver TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Valider strekkode pÃ¥ boksen/spannet med base",
        validateBarcodeRefill: "Valider strekkode pÃ¥ kanisteren fÃ¸r pÃ¥fylling",
        validateColorantsDuringInit: "Valider tonepasta under initialisering"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Handlinger kjÃ¸res pÃ¥ maskinen",
        addLevel: "LEGG TIL NIVÃ",
        addManually: "Legg til manuelt",
        barcodeNotSet: "Beholder %{colorantName} (%{canisterName}) er ikke tildelt en strekkode.",
        cancel: "AVBRYT",
        dispenseFormula: "Oppskrift",
        dispenserIdle: "Maskinen er inaktiv",
        dispenserIsBusy: "Maskin i bruk",
        dispenserIsIdle: "Maskinen er inaktiv",
        dispenserIsReady: "Maskinen er klar til ytterligere oppgaver",
        dispensingFormula: "Oppskrift",
        errorCode: "Feilkode",
        explanation: "Forklaring",
        fillToMax: "Fyll maksimalt",
        finished: "Ferdig",
        inProgress: "I gang",
        machineIsReady: "Maskinen er klar",
        moveToFill: "Flytt til utfylling",
        noMachineDialog: "Ingen maskin er tilkoblet",
        of: "fra",
        packageSize: "PakkestÃ¸rrelse",
        placeBaseCan: "Plasser boks/spann med base",
        pleaseCheckYourMachineConnection: "Sjekk maskinens tilkobling",
        pleaseRefill: "Fyll pÃ¥",
        solution: "LÃ¸sning",
        subErrors: "Feil",
        timeToEnd: "Tid til slutt",
        tintingFormula: "Oppskrift",
        tintingPleaseWait: "Blander farge, vent litt",
        validateBaseCan: "Valider boks/spann med base",
        waiting: "Venter"
    },
    rccSettigns: {
        rccSettigns: "Ingen RCC-tilkobling",
        rccUrl: "RCC URL"
    },
    rccSpectroDialog: {
        100: "Oppretter tilkobling til din enhet via Bluetooth. SÃ¸rg for at du har Bluetooth aktivert og instrumentet slÃ¥tt pÃ¥.",
        101: "Instrumentet ble ikke funnet. Vil du prÃ¸ve igjen?",
        110: "SÃ¸rg for at Nano er tilkoblet, og trykk pÃ¥ instrumentknappen for Ã¥ starte initialiseringen",
        111: "Nano ble ikke funnet. Vil du prÃ¸ve igjen?",
        112: "Koble fra Nano, vent i 10 sekunder, koble til igjen og fortsett",
        120: "Kobler til din enhet, vent litt",
        121: "Instrumentet ble ikke funnet. Vil du prÃ¸ve igjen?",
        200: "Plasser instrumentet pÃ¥ den svarte flisen og fortsett, eller trykk pÃ¥ instrumentknappen",
        201: "Plasser instrumentet pÃ¥ den svarte flise og fortsett",
        202: "Plasser instrumentet pÃ¥ den svarte flisen, og trykk pÃ¥ instrumentknappen",
        205: "Plasser instrumentet pÃ¥ den hvite flisen, og fortsett eller trykk pÃ¥ instrumentknappen",
        206: "Plasser instrumentet pÃ¥ den hvite flisen og fortsett",
        207: "Plasser instrumentet pÃ¥ den hvite flisen, og trykk pÃ¥ instrumentknappen",
        210: "Plasser instrumentet pÃ¥ diagnostikkflisen og fortsett, eller trykk pÃ¥ instrumentknappen",
        211: "Plasser instrumentet pÃ¥ diagnostikkflisen og fortsett",
        212: "Plasser instrumentet pÃ¥ diagnostikkflisen, og trykk pÃ¥ instrumentknappen",
        215: "Lukk instrumentdekslet og fortsett, eller trykk pÃ¥ instrumentknappen",
        216: "Lukk instrumentdekslet og fortsett",
        217: "Lukk instrumentdekslet, og trykk pÃ¥ instrumentknappen",
        220: "Plasser instrumentet pÃ¥ nullflisen og fortsett, eller trykk pÃ¥ instrumentknappen",
        221: "Plasser instrumentet pÃ¥ nullflisen og fortsett",
        222: "Plasser instrumentet pÃ¥ nullflisen, og trykk pÃ¥ instrumentknappen",
        224: "Plasser instrumentet pÃ¥ kalibreringsplaten og fortsett eller trykk pÃ¥ instrumentknappen",
        225: "Plasser instrumentet pÃ¥ kalibreringsputen og fortsett",
        226: "Plasser instrumentet pÃ¥ kalibreringsplaten og trykk pÃ¥ instrumentknappen",
        227: "Plasser instrumentet pÃ¥ kalibreringsplaten og trykk pÃ¥ instrumentknappen",
        295: "Avslutt kalibreringen i drivervinduet",
        296: "Instrumentet er ikke tilkoblet, vil du Ã¥pne tilkoblingen til det?",
        297: "KlargjÃ¸ring til kalibreringstrinn, vent litt",
        298: "Kalibrerer, vent litt",
        299: "Avslutt kalibreringstrinn, vent litt",
        300: "Plasser instrumentet pÃ¥ prÃ¸ven og fortsett, eller trykk pÃ¥ instrumentknappen",
        301: "Plasser instrumentet pÃ¥ prÃ¸ven og fortsett",
        302: "Plasser instrumentet pÃ¥ prÃ¸ven, og trykk pÃ¥ instrumentknappen",
        303: "Instrumentet er ikke kalibrert. Vil du fortsette med kalibreringen?",
        304: "Instrumentet er ikke tilkoblet, vil du Ã¥pne tilkoblingen til det?",
        390: "Velg mÃ¥lemodus",
        395: "Avslutt mÃ¥lingen i drivervinduet",
        397: "KlargjÃ¸r mÃ¥ling, vent litt",
        398: "MÃ¥ler, vent litt",
        399: "Avslutter mÃ¥ling, vent litt",
        498: "Laster ned mÃ¥linger, vent litt",
        499: "Laster ned alle mÃ¥linger, vent litt",
        900: "Instrumentfeil oppsto %{0}: %{1}. Vil du prÃ¸ve igjen?",
        901: "Instrumentfeil oppsto: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Datamaskinen skal have Bluetooth-tilkobling. Spektrometeret skal pares med datamaskinen. Krever Windows 10 med 2018 hÃ¸stoppdatering.",
        DatacolorSilent:
            "NÃ¥r lydlÃ¸s tilstand er i bruk, vises Datacolor-vinduer direkte i %{name}. I disse vinduene kan spektroparametere ikke endres.",
        DatacolorUseDiagnosticTile: "Bruk av diagnostikkflis forbedrer mÃ¥lekvaliteten.",
        comPort: "COM-port",
        diagnosticTile: "Datafarge bruker diagnostikkfliser",
        measureModes: "MÃ¥lemodus",
        measureModesOrder: "MÃ¥lemodus rekkefÃ¸lge",
        model: "Modell",
        noSpectroAvailable: "Ingen spektrometere er tilgjengelige",
        rccSpectroSettings: "Spektrometerinnstillinger",
        save: "Lagre innstillinger",
        silent: "Datafarge taus",
        simulationPath: "Simuleringsbane",
        spectroType: "Spektrometertype",
        useProfiledValues: "Bruk profilerte verdier"
    },
    recirculateChannels: {
        recirculateAllChannels: "Resirkuler alle kanaler",
        recirculateChannels: "Resirkulerer kanaler",
        recirculatingSpeed: "Resirkuleringshastighet",
        recirculatingTime: "Resirkuleringstid",
        startRecirculating: "Start resirkulering"
    },
    redlikeLight: {
        finishPreviousSteps: "FullfÃ¸r tidligere trinn",
        searchBySpectro: "SÃ¸k med spektrometer",
        searchFormula: "SÃ¸k etter oppskrift",
        selectBase: "Velg base",
        selectColor: "Velg farge",
        selectCustomer: "Velg kunde",
        selectFandeck: "Velg fargekart",
        selectPackage: "Velg pakke",
        selectProduct: "Velg produkt",
        startSelectFandeck: "Start med Ã¥ velge et fargekart",
        startSelectProduct: "Start med Ã¥ velge et produkt",
        stepByStepProgress: "Du kan gÃ¥ videre trinn for trinn",
        typeHereToSearch: "Tast inn her for Ã¥ sÃ¸ke",
        typeToFilter: "Filtertype"
    },
    restartModal: {
        computerNeedsRestart: "Datamaskinen mÃ¥ startes pÃ¥ nytt",
        notCompletelyTranslated:
            "SprÃ¥kendring krever omstart av programvare. Noen deler av programvaren er kanskje ikke fullstendig oversatt pÃ¥ dette tidspunktet.",
        restartIsRequired: "Programvareoppstart er nÃ¸dvendig etter at endringene er gjort.",
        softwareNeedsRestart: "%{name} Trenger omstart!"
    },
    searchPanel: {
        basePlaceholder: "eller skriv en base",
        baseStartPlaceholder: "Skriv inn en base",
        colorCodeNamePlaceholder: "eller skriv inn reseptkode/-navn",
        colorCodeNameStartPlaceholder: "Start med Ã¥ skrive inn et reseptkode/-navn",
        colorCodePlaceholder: "eller legg inn en oppskriftskode",
        colorCodeStartPlaceholder: "Start med Ã¥ legge inn en oppskriftskode",
        colorNameCodePlaceholder: "eller skriv inn reseptnavn/-kode",
        colorNameCodeStartPlaceholder: "Start med Ã¥ skrive inn et reseptnavn/-kode",
        colorNamePlaceholder: "eller legg inn et oppskriftsnavn",
        colorNameStartPlaceholder: "Legg inn et oppskriftsnavn",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "eller legg inn et fargekart",
        fandeckStartPlaceholder: "Start med Ã¥ legge inn et fargekart",
        formulaByColor: "Oppskrift etter farge",
        noResultsFound: "Ingen resultater funnet",
        packagePlaceholder: "eller skriv inn et produktnavn",
        packageStartPlaceholder: "Skriv inn et produktnavn",
        productPlaceholder: "eller legg inn et produktnavn",
        productStartPlaceholder: "Start med Ã¥ legge inn et produktnavn",
        standard: "Standard",
        typeFandeckToFilter: "SÃ¸k etter fargekart",
        typeProductToFilter: "SÃ¸k etter produktnavn"
    },
    sendOrderModal: {
        customNote: "Notat om spesiallagingen",
        noCompatibleServers: "Ingen kompatible servere er tilgjengelige i ditt nettverk",
        orderOverview: "Ordreoversikt",
        selectTargetMachine: "Velg aktuell maskin",
        sendOrder: "Send ordre",
        sendOrderTo: "Ordren vil bli sendt til %{serverName}",
        targetMachine: "Aktuell maskin"
    },
    server: {
        computerId: "Datamaskin-ID",
        ip: "IP",
        selectServer: "Velg en av de tilgjengelige serverne",
        server: "Server"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Aktive server-programtillegg",
        currentlyActive: "De aktuelle aktive programtilleggene",
        plugin: "Programtillegg",
        pluginName: "Navn pÃ¥ programtillegg",
        statusActive: "Aktiver",
        statusInactive: "Deaktiver"
    },
    serviceActionsSettings: {
        canisterLevel: "KanisternivÃ¥",
        capClose: "Lukk",
        capMiddle: "Midterst",
        capOpen: "Ãpen",
        cleanAllChannels: "RengjÃ¸r alle",
        cleanChannels: "RengjÃ¸r kanaler",
        computer: "Datamaskin",
        computerReboot: "Omstart av datamaskin",
        computerShutdown: "Nedstenging av datamaskin",
        connectMachine: "Koble til maskin",
        general: "Generelt",
        initialize: "Initialisere",
        noMachineIsConnected: "Ingen maskin er tilkoblet",
        plug: "Koble til",
        plugger: "Tilkoblingsknapp",
        punch: "Stanser",
        puncher: "Stanserknapp",
        purgeChannels: "Rens kanaler",
        recirculate: "Resirkuler",
        recirculateAllChannels: "Resirkuler alle",
        recirculateChannels: "Resirkuler kanaler",
        serviceActions: "Servicehandlinger",
        setCanisterLevel: "Still inn kanisternivÃ¥er",
        shelfDown: "Hylle ned",
        shelfUp: "Hylle opp",
        showServiceWindow: "Vis servicevindu",
        smartPurgeAllChannels: "Smart rensing av alle kanaler",
        smartPurgeChannels: "Smart rensing av kanaler",
        startErrorReset: "Nullstil startfeil",
        startHardReset: "Start hard nullstilling",
        startReset: "Start nullstilling",
        stirAllCanisters: "RÃ¸r alle",
        stirCanisters: "RÃ¸r",
        stirCanistersMore: "RÃ¸r kanister"
    },
    spectroMode: {
        eggshell: "Eggeskall",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matt",
        pearl: "Perle",
        satin: "S",
        selectGlossLevel: "Sammenlign fargeprÃ¸ven med glansskalaen og velg glansnivÃ¥",
        semiGloss: "Halvblank"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibrer",
        calibrateInstrument: "Kalibrer instrument",
        connectDevice: "Koble til enhet",
        connectedTo: "Tilkoblet",
        connectingDevice: "Tilkobler enheten din",
        deselectAll: "Velg bort alle",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Enheten din er ikke kalibrert",
        eraseResult: "Slett resultat",
        filter: "Filter",
        foundInFormulas: "Funnet i oppskrifter",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Instrumentet ditt mÃ¥ kalibreres.",
        manualInput: "Manuell inntasting",
        measure: "MÃ¥le",
        measurementResult: "MÃ¥leresultat",
        noFilters: "Ingen filtre tilgjengelig",
        noFormulas: "Ingen oppskrifter ble funnet",
        noSelectedSpectro: "Ingen spektrometere er valgt",
        notSelected: "Ikke valgt",
        pressConnectButton: "Kontroller at enheten er tilkoblet, og trykk pÃ¥ tilkoblingsknappen",
        searchFormulas: "SÃ¸k etter oppskrift",
        selectSpectro: "Velg spektrometer",
        showDetails: "Vis detaljer",
        skipCalibration: "Hopp over kalibrering",
        spectroIsConnected: "Spektrometeret er tilkoblet",
        spectroIsReady: "Spektrometeret er klart",
        spectroReady: "Enheten er klar til ytterligere oppgaver",
        startCalibrateNow: "Start kalibrering nÃ¥",
        startMeasureText: "Enheten er kalibrert, og du kan begynne Ã¥ mÃ¥le",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Toleranse for Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Spesiallaget %{1} %{2}",
        deleteSelectedRecords: "Slett valgte poster",
        exportHistory: "Eksporthistorikk",
        finishFormula: "Ferdigstill oppskrift",
        foundInFormulas: "Funnet i oppskrifter",
        hideHiddenRecords: "Ikke vis skjulte poster",
        hideSelectedRecord: "Skjul valgt post",
        historicalFormula: "Historisk formel",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Gjenopprett valgt post",
        showAllRecords: "Vis alle poster",
        standardFormula: "Standard formula",
        unknownFormula: "Ukjent formel"
    },
    stirCanisters: {
        selectCanisters: "Velg kanister",
        startStirring: "Start rÃ¸ring",
        stirAllCanisters: "RÃ¸r alle kanistere",
        stirCanisters: "RÃ¸r kanistere",
        stirringSpeed: "RÃ¸rehastighet",
        stirringTime: "RÃ¸retid "
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Intet element er tildelt strekkode %{code}",
        pleaseScanBarcode: "Skann strekkoden for base, produkt, pakke eller andre objekter",
        testBarcodes: "Test strekkode"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Siste",
        next: "Neste"
    },
    ufiCodeModal: {
        currentStatus: "NÃ¥vÃ¦rende status",
        detailedInfoForColorant: "Detaljert informasjon for tonefarge %{colorantName}",
        userSetUfiCode: "Brukersett UFI -kode, gjeldende verdi"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Grunnleggende validering av UFI -kode",
        confirmColorantRefilling: "Bekreft pÃ¥fylling av tonefarge",
        enableUfiCodes: "Aktiver UFI -koder",
        printUfiCode: "Skriv ut hvis mengden tonefarge overskrides",
        printUfiCodePercentage: "Skriv ut prosent hvis prosent tonefarge overskrides",
        scanOrTypeUfiCode: "Skann eller skriv inn UFI -kode",
        scanOrTypeUfiCodeOfBase: "Skann eller skriv inn UFI -koden til basen",
        ufiCodesByPercentage: "Bruk UFI -koder i prosent",
        ufiCodesFromDatabase: "Bruk UFI -koder fra databasen",
        ufiCodesFromLastFilling: "Bruk UFI -koder fra den siste fyllingen"
    },
    userSettings: {
        addUser: "Legg til bruker",
        assignedUserGroups: "Tildelte brukergrupper",
        availableUserGroups: "Tilgjengelige brukergrupper",
        barcode: "Strekkode",
        confirmNewPassword: "Bekreft strekkode",
        editPassword: "Rediger kodeord",
        editUser: "Rediger bruker",
        enableAutoLogin: "Aktiver automatisk pÃ¥logging",
        newPassword: "Ny adgangskode",
        noChange: "Ingen endringer skal lagres",
        oldPassword: "Gammel adgangskode",
        password: "Adgangskode",
        passwordsDoNotMatch: "Adgangskodene stemmer ikke overens",
        restoreUser: "Denne brukeren er slettet. Vil du gjenopprette brukeren?",
        userGroup: "User Group",
        userGroups: "Brukergrupper",
        userManagement: "Brukeradministrasjon",
        userSettings: "Brukerinnstillinger",
        username: "Brukernavn",
        usernameIsMissing: "Brukernavn mangler"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Fredag",
        monday: "Mandag",
        saturday: "LÃ¸rdag",
        sunday: "SÃ¸ndag",
        thursday: "Torsdag",
        tuesday: "Tirsdag",
        wednesday: "Onsdag"
    },
    welcome: {
        availableDatabase: "Serveren kan ikke opprette tilkobling til databasen. Kontroller databasekonfigurasjonen.",
        availableDatabaseLocalError: "Feil under tilkobling til den lokale databasen (feil fil, ugyldig adgangskode)",
        availableDatabaseLocalMissing: "Den lokale databasefilen mangler",
        availableDatabaseLocalUpdate: "Lokal database skal oppdateres til nyere versjon",
        availableDatabaseMainAndLocalError:
            "Feil under tilkobling til bÃ¥de hoved- og lokale databaser (feil fil, ugyldig adgangskode)",
        availableDatabaseMainAndLocalMissing: "Hoved- og lokale databasefiler mangler",
        availableDatabaseMainAndLocalUpdate: "BÃ¥de hoveddatabase og lokale databaser skal oppdateres til nyere versjon",
        availableDatabaseMainError: "Feil under tilkobling til bÃ¥de hoveddatabasen (feil fil, ugyldig adgangskode)",
        availableDatabaseMainMissing: "Hoveddatabasefilen mangler",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Hoveddatabasen skal oppdateres til nyere versjon",
        closing: "Programvaren lukkes",
        compatibility: "Kontroller versjonen av serveren. Klienten er kun kompatibel med server %{0} eller nyere.",
        compatibilityCheck: "Kompatibilitetskontroll pÃ¥gÃ¥r",
        compatibilityDatabase: "Databasen er ikke kompatibel med serveren. Kontroller databasekonfigurasjonen.",
        connectingServer: "Oppretter tilkobling til serveren pÃ¥ %{ip}",
        databaseCompatibility: "Databasen er ikke kompatibel med den aktuelle programvaren",
        databasesCompatibility: "Databasen er ikke kompatibel med den aktuelle programvaren",
        licenseVerification: "Lisensgodkjenning pÃ¥gÃ¥r",
        loading: "Laster",
        lostConnection: "Tilkobling til serveren er avbrutt",
        moduleMessage:
            "VÃ¦r oppmerksom pÃ¥ modulvalget siden fremtidige endringer av modulen kun vil vÃ¦re tilgjengelig for privilegerte brukere.",
        refresh: "Oppdater",
        restoring: "Gjenoppretter tilkoblingen",
        selectModule: "Velg en av de tilgjengelige modulene.",
        stopUpdate: "Stopp oppdatering",
        updateDatabase: "Oppdater database",
        updatingDatabase: "Databasen oppdateres",
        updatingDatabases: "Databaser oppdateres",
        updatingWarning: "Ikke lukk dette vinduet. En uopprettelig prosess pÃ¥gÃ¥r.",
        updatingWarningInfo: "Lukking vil medfÃ¸re dataskader som ikke kan repareres."
    }
};
